// Tamil language file
export const TA = {
  preparing_zip: "ஜிப் தயாராகிறது…",
  compressing: "சுருக்கப்படுகிறது…",
  info_icon: "முடிக்கப்பட்டதாகக் குறிக்கப்பட்ட பிறகு, கூடுதல் உறுப்பினர்கள் சேர முடியாது அல்லது சேர்க்க முடியாது, மற்றும் அனைத்து அரட்டை குழுக்களும் செயலிழக்கும். திட்டம், அனைத்து அரட்டை குழுக்கள் மற்றும் தரவுகளுடன், செயலிழந்த நிலையில் அணுகக்கூடியதாக இருக்கும் என்பதை நினைவில் கொள்ளவும்.",
  mark_is_done: "திட்டத்தை முடிக்கப்பட்டதாகக் குறிக்க விரும்புகிறீர்களா? குறிக்கப்பட்ட பிறகு, கூடுதல் உறுப்பினர்கள் சேர முடியாது அல்லது சேர்க்க முடியாது, மற்றும் அனைத்து அரட்டை குழுக்களும் செயலிழக்கும். திட்டம், அனைத்து அரட்டை குழுக்கள் மற்றும் தரவுகளுடன், செயலிழந்த நிலையில் அணுகக்கூடியதாக இருக்கும் என்பதை நினைவில் கொள்ளவும்.",
  mark_not_done: "திட்டத்தை மீண்டும் திறக்க விரும்புகிறீர்களா? திறந்ததாகக் குறிக்கப்பட்ட பிறகு, கூடுதல் உறுப்பினர்கள் சேரலாம் அல்லது சேர்க்கலாம், மற்றும் அனைத்து அரட்டை குழுக்களும் மீண்டும் செயல்படுத்தப்படும்.",
  mark_as_completed: "திட்டத்தை முடிக்கப்பட்டதாகக் குறிக்கவும்",
  room_completed: "திட்டம் முடிக்கப்பட்டது",
  room_members: "திட்ட உறுப்பினர்கள்",
  deactivated_rooms: "செயலிழந்த திட்டங்கள்",
  deactivated_chats: "செயலிழந்த அரட்டைகள்",
  completed_rooms: "முடிக்கப்பட்ட திட்டங்கள்",
  request_to_join_a_room: 'திட்டத்தில் சேர்வதற்கான கோரிக்கை',
  wants_to_rejoin_room: 'Username திட்டம் Roomname-இல் மீண்டும் சேர விரும்புகிறார்.',
  invited_you_to_join_room: 'Username உங்களை Roomname திட்டத்தில் சேர அழைத்தார்.',
  restart: "மீண்டும் தொடங்கவும்",
  update_text: "புதிய புதுப்பிப்பு கிடைக்கிறது. புதுப்பிப்பை நிறுவ மீண்டும் தொடங்கவும் என்பதைக் கிளிக் செய்யவும்.",
  update_availble: "புதுப்பிப்பு கிடைக்கிறது",
  Loading: "ஏற்றுகிறது...",
  logout: "வெளியேறு",
  back: 'பின்',
  company_list: "நிறுவன பட்டியல்",
  followers: "பின்தொடர்பவர்கள்",
  followings: "பின்தொடர்பவை",
  article: "கட்டுரை",
  companies: "நிறுவனங்கள்",
  one_to_one_chat: " ஒன்றுக்கு ஒன்று அரட்டை",
  profile: "சுயவிவரம்",
  company: "நிறுவனம்",
  company_selection: "நிறுவன தேர்வு",
  home: "முகப்பு",
  contact: "தொடர்பு ",
  add_company: "நிறுவனத்தைச் சேர்க்கவும் ",
  add_project: "திட்டத்தைச் சேர்க்கவும் ",
  capacities: "திறன்கள் ",
  work_area: "வேலை பகுதி",
  company_services: "நிறுவன சேவைகள்",
  website: "வலைத்தளம்",
  search_contacts: "தொடர்புகளைத் தேடுங்கள்",
  add_or_join_a_company: "நிறுவனத்தைச் சேர்க்கவும் அல்லது சேருங்கள்",
  follow: "பின்தொடரவும்",
  following: "பின்தொடர்கிறது",
  like: "விரும்பு",
  company_contacts: "நிறுவன தொடர்பு",
  leave_the_company: "நிறுவனத்தை விட்டு வெளியேறு",
  news: "செய்திகள்",
  earlier: "முன்பு",
  action: "செயல்",
  another_action: "மற்றொரு செயல்",
  something_else: "வேறு ஏதாவது",
  search: "தேடு",
  search_rooms: "திட்டங்களைத் தேடுங்கள்",
  search_articles: "கட்டுரைகளைத் தேடுங்கள்",
  contacts: "தொடர்புகள்",
  suggestions: "பரிந்துரைகள்",
  project_list: "திட்ட பட்டியல்",
  search_results: "தேடல் முடிவுகள்",
  add_or_join_project: "திட்டத்தைச் சேர்க்கவும் அல்லது சேருங்கள்",
  details: "விவரங்கள்",
  your_position_within_company: "தயவுசெய்து நிறுவனத்திற்குள் உங்கள் பதவியைத் தேர்ந்தெடுக்கவும்.",
  close_modal: "மூடு",
  map: "வரைபடம்",
  or: "அல்லது",
  name: "பெயர்*",
  street: "தெரு*",
  house_number: "வீட்டு எண்",
  postal_code: "அஞ்சல் குறியீடு",
  city: "நகரம்*",
  opened_by: "திறக்கப்பட்டது:",
  project_No: "திட்ட-எண்: ",
  building_type: "கட்டிட வகை*",
  building_types: "கட்டிட வகை",
  add_join: "சேர்க்கவும்/சேருங்கள்",
  mandatory_fiels: "*கட்டாய புலங்கள்",
  invalid_fiels: "இந்த புலம் தேவையானது",
  add_or_join_company: "நிறுவனத்தைச் சேர்க்கவும் அல்லது சேருங்கள்",
  name_of_the_company: "நிறுவனத்தின் பெயர்",
  edit_company_details: "நிறுவன விவரங்களைத் திருத்தவும்",
  branch_of_the_building_industry: "கட்டுமானத் தொழிலின் கிளை",
  corporate_form: "நிறுவன வடிவம்",
  position_within_company: "நிறுவனத்திற்குள் பதவி",
  request_confirmation: "நிலுவையில் உள்ள திட்டக் கோரிக்கைகள்",
  company_e_mail: "நிறுவன மின்னஞ்சல்",
  type_of_filter: "வடிகட்ட தட்டச்சு செய்யவும்...",
  setting: "அமைப்பு",
  dashboard: "டாஷ்போர்டு",
  settings: "அமைப்புகள்",
  views: "பார்வைகள்",
  times_seen: "முறை பார்க்கப்பட்டது",
  see_more: "...மேலும்",
  see_less: "...குறைவாக",
  in_search: "தேடலில்",
  reset_password: "கடவுச்சொல்லை மீட்டமைக்கவும்",
  submit: "சமர்ப்பிக்கவும்",
  password: "கடவுச்சொல்",
  email: "மின்னஞ்சல்",
  confirm_password: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
  reset_email: "மின்னஞ்சலை மீட்டமைக்கவும்",
  update: "புதுப்பிக்கவும்",
  new_email: "புதிய மின்னஞ்சல்",
  kjuup_message: "Kjuup செய்தி",
  delete_profile: "சுயவிவரத்தை நீக்கவா?",
  my_position: "எனது பதவி:",
  add: "சேர்க்கவும்",
  owner_company_admin: "நிறுவன நிர்வாகி:",
  owner_company_admin_new: "நிறுவன நிர்வாகி",
  mutual_contact: "பரஸ்பர தொடர்பு",
  mutual_contacts: "பரஸ்பர தொடர்புகள்",
  co_owner: "கூட்டு உரிமையாளர்",
  managing_director: "நிர்வாக இயக்குநர்",
  associate: "சங்க உறுப்பினர்",
  secretary: "செயலாளர்",
  employee: "ஊழியர்",
  project_manage: "திட்ட மேலாளர்",
  auto_chat_translation: "தன்னியக்க அரட்டை மொழிபெயர்ப்பு",
  translate_room_group_names: "அரட்டை குழு பெயர்களை மொழிபெயர்க்கவும்",
  translate_room_group_names_info: "இயக்கப்பட்டால், அரட்டை குழு பெயர்கள் இடைமுக மொழியில் தானாக மொழிபெயர்க்கப்படும்.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "இயக்கப்பட்டால், பயன்பாட்டைத் திறக்கும்போது செய்திகளுக்குப் பதிலாக மின்னஞ்சல் தாவல் இயல்பாகத் திறக்கும்.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "மொழி",
  english: "ஆங்கிலம்",
  german: "ஜெர்மன்",
  french: "பிரெஞ்சு",
  italian: "இத்தாலியன்",
  change_language: "மொழியை மாற்றவும்",
  my_companies: "எனது நிறுவனங்கள்",
  employees: "ஊழியர்கள்",
  invite_with_a: "Kjuup-க்கு அழைக்கவும்",
  add_member: "உறுப்பினரைச் சேர்க்கவும்",
  add_user: "பயனரைச் சேர்க்கவும்",
  send_location: "இடத்தை அனுப்பவும்",
  assign_admin_rights: "நிர்வாக உரிமையை சரிசெய்யவும்",
  deactivate_company: "நிறுவனத்தை செயலிழக்கச் செய்யவும்",
  remove_employees: "ஊழியர்களை அகற்றவும்",
  remove_members: "உறுப்பினர்களை அகற்றவும்",
  no_user_found: "பயனர் கிடைக்கவில்லை!",
  approve: "அனுமதிக்கவும்!",
  deselect_all: "அனைத்தையும் தேர்வுநீக்கவும்",
  select_all: "அனைத்தையும் தேர்ந்தெடு",
  translation_on_building_projects: "திட்டங்களில் மொழிபெயர்ப்பு",
  reported_capacities: "அறிக்கை செய்யப்பட்ட சேவைகள்",
  up_to_50m_exact: "50 மீ வரை துல்லியமான",
  company_details_service: "நிறுவன சேவைகள்",
  company_contact: "நிறுவன தொடர்பு",
  invite_with_link: "Kjuup-க்கு அழைக்கவும்",
  share_link: "இணைப்பைப் பகிரவும்",
  share_company_link: "இணைப்பைப் பகிரவும்",
  qr_code: "QR குறியீடு",
  copy_link: "இணைப்பை நகலெடுக்கவும்",
  cancel_link: "இணைப்பை ரத்துசெய்யவும்",
  who_has_confirmed_services: "யார் உங்கள் சேவைகளை உறுதிப்படுத்தியுள்ளனர்?",
  projectss: "திட்டங்கள்",
  add_services: "சேவைகளைச் சேர்க்கவும்",
  services: "சேவைகள்",
  save_text: "சேமிக்கவும்",
  share_on: "பகிரவும்:",
  articlen: "கட்டுரை",
  invite_user_to_confirm_service: "நிறுவனத்திற்கு சேவைகளை உறுதிப்படுத்த பயனர்களை அழைக்கவும்.",
  link_copied: "இணைப்பு நகலெடுக்கப்பட்டது!",
  email_copied: "மின்னஞ்சல் நகலெடுக்கப்பட்டது!",
  personal_article: "தனிப்பட்ட கட்டுரை",
  company_article: "நிறுவன கட்டுரை",
  characters_remaining: "மீதமுள்ள எழுத்துக்கள்",
  optional_information: "விருப்பமான தகவல்",
  project: "திட்டம்",
  projects: "திட்டங்கள்...",
  abort: "நிராகரிக்கவும்",
  preview: "முன்னோட்டம்",
  post: "இடுகையிடவும்",
  of: "இன்",
  remove: "அகற்றவும்",
  free_capacity: "வேலை போர்டல்",
  current_status_overview: "தற்போதைய நிலை கண்ணோட்டம்",
  report_capacities: "சேவைகளை அறிக்கை செய்யவும்",
  report_text: "அறிக்கை",
  search_capacities: "ஒப்பந்ததாரர்களைக் கண்டறியவும்",
  add_project_user: "திட்ட பயனரைச் சேர்க்கவும்",
  media: "ஊடகம்",
  links: "இணைப்புகள்",
  docs: "ஆவணங்கள்",
  featured_products: "முன்னிலைப்படுத்தப்பட்ட தயாரிப்புகள்...",
  title: "தலைப்பு",
  text: "உரை",
  feed_details: "ஊட்ட விவரங்கள்",
  add_employee: "ஊழியரைச் சேர்க்கவும்",
  latest: "சமீபத்திய",
  my_projects: "எனது திட்டங்கள்",
  cancel: "ரத்துசெய்யவும்",
  continue: "தொடரவும்",
  role_in_the_building_industry: "கட்டுமானத் தொழிலில் பங்கு",
  als: "என",
  join: "சேருங்கள்",
  find: "கண்டறியவும்",
  request_to_join_a_company: "நிறுவனத்தில் சேர்வதற்கான கோரிக்கை",
  wants_to_join_the_company: "நிறுவனத்தில் சேர விரும்புகிறது",
  filter_by: "வடிகட்டவும்",
  ok: "சரி",
  close: "மூடு",
  weekly_statistics: "வாராந்திர புள்ளிவிவரங்கள்",
  is_following_you: "உங்களைப் பின்தொடர்கிறது.",
  as: "என",
  has_joined_the: "நிறுவனத்தில் சேர்ந்துள்ளது",
  has_looked_at_your_profile: "உங்கள் சுயவிவரத்தைப் பார்த்துள்ளது.",
  time: "நேரம்",
  in_searches_in_past_week: "கடந்த வாரத்தில் தேடல்களில்.",
  has_liked_your_article: "உங்கள் கட்டுரையை விரும்பியுள்ளது.",
  has_published_a_new_article: "புதிய கட்டுரையை வெளியிட்டுள்ளது.",
  you: "நீங்கள்",
  all_views: "அனைத்து பார்வைகள்",
  all_profile_views: "அனைத்து சுயவிவர பார்வைகள்",
  mutual_company: "பரஸ்பர நிறுவனம்",
  artical_text: "கட்டுரை எழுதவும்...",
  you_have_appeared: "நீங்கள் தோன்றியுள்ளீர்கள்",
  your_request_at_the_company: "நிறுவனத்தில் உங்கள் கோரிக்கை",
  times_you_have_appeared_in_searches: "முறை நீங்கள் தேடல்களில் தோன்றியுள்ளீர்கள்",
  appear_more_often_in_searches: "தேடல்களில் அடிக்கடி தோன்றவும்",
  you_have_been_found: "நீங்கள் கண்டறியப்பட்டுள்ளீர்கள்",
  improve_profile: "சுயவிவரத்தை மேம்படுத்தவும்",
  choose_existing_contact_for_single_chat: "ஒற்றை அரட்டைக்கு இருக்கும் தொடர்பைத் தேர்ந்தெடுக்கவும்:",
  in_order_to_add_new_contacts: "புதிய தொடர்புகளைச் சேர்க்க, தயவுசெய்து சுயவிவர பக்கத்தில் புதிய தொடர்புகளைத் தேடவும்.",
  times_in_searches_in_the_last_week: "கடந்த வாரத்தில் தேடல்களில் முறை. உங்கள் சுயவிவரத்தைப் புதுப்பிக்கவும் மற்றும் எளிதாகக் கண்டறிய அதிக விவரங்களைச் சேர்க்கவும்.",
  has_been_confirmed: "உறுதிப்படுத்தப்பட்டது.",
  have_joined_the: "சேர்ந்துள்ளனர் ",
  building_project: " கட்டுமான திட்டம்.",
  select_with_which_company_you_want_to_connect_to_the_project: "நீங்கள் பிரதிநிதித்துவப்படுத்தும் நிறுவனத்தைத் தேர்ந்தெடுக்கவும். இது மற்ற பங்கேற்பாளர்களுக்குக் காட்டப்படும்.",
  select_with_which_company_you_want_to_connect_to_the_chat: "நீங்கள் பிரதிநிதித்துவப்படுத்தும் நிறுவனத்தைத் தேர்ந்தெடுக்கவும். இது மற்ற பங்கேற்பாளர்களுக்குக் காட்டப்படும்.",
  select_internal_section: "தயவுசெய்து உள் பிரிவைத் தேர்ந்தெடுக்கவும்",
  select_profile_image: "சுயவிவர படத்தைத் தேர்ந்தெடுக்கவும்",
  share_user: "பயனரைப் பகிரவும்",
  contact_sender_message: "Kjuup-இன் உறுப்பினரல்லாதவரை Kjuup-க்கு அழைக்க இந்த இணைப்பைப் பகிரவும். இந்த இணைப்பை பலர் பதிவு செய்ய பயன்படுத்தலாம்.",
  project_sender_message: "Kjuup-இன் உறுப்பினரல்லாதவரை திட்டப் பெயருக்கு அழைக்க இந்த இணைப்பைப் பகிரவும். இந்த இணைப்பை பலர் பதிவு செய்ய மற்றும் Kjuup-இல் திட்டப் பெயரில் சேர பயன்படுத்தலாம்.",
  company_sender_message: "Kjuup-இன் உறுப்பினரல்லாதவரை நிறுவன நிறுவனப் பெயருக்கு அழைக்க இந்த இணைப்பைப் பகிரவும். இந்த இணைப்பை பலர் பதிவு செய்ய மற்றும் Kjuup-இல் நிறுவனத்தில் சேர பயன்படுத்தலாம்.",
  contact_receivers_message: "Kjuup-இல் சேர்வதற்கான அழைப்பு இணைப்பு. தயவுசெய்து kjuup-க்கு பதிவு செய்ய இணைப்பைக் கிளிக் செய்யவும்.",
  iphone: "iPhone:",
  iphone_recivers_message: "நீங்கள் Apple App Store-ன் மூலம் Kjuup-ஐ நிறுவுகிறீர்கள் என்றால், பதிவு செய்ய முடியுமாறு வெற்றிகரமாக பதிவிறக்கிய பிறகு இந்த இணைப்பைக் கிளிக் செய்ய வேண்டும்.",
  project_receivers_message: "Kjuup-இல் திட்டப் பெயரில் சேர்வதற்கான அழைப்பு இணைப்பு. தயவுசெய்து Kjuup-க்கு பதிவு செய்ய மற்றும் திட்டப் பெயரில் சேர இணைப்பைக் கிளிக் செய்யவும்.",
  company_receivers_message: "Kjuup-இல் நிறுவன நிறுவனப் பெயருக்கான அழைப்பு இணைப்பு. தயவுசெய்து Kjuup-க்கு பதிவு செய்ய மற்றும் நிறுவன நிறுவனப் பெயரில் சேர இணைப்பைக் கிளிக் செய்யவும்.",
  sign_in: "உள்நுழையவும்",
  enter_your_email_add: "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
  forgot_password: "கடவுச்சொல்லை மறந்துவிட்டீர்களா",
  dont_have_account: "கணக்கு இல்லையா?",
  register: "பதிவு செய்யவும்",
  get_app: "பயன்பாட்டைப் பெறவும்",
  registration: "பதிவு",
  dep_ing: "Dipl.-Ing.",
  dr: "டாக்டர்",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "பேராசிரியர்",
  first_name: "முதல் பெயர்",
  last_name: "கடைசி பெயர்",
  have_an_account: "கணக்கு உள்ளதா?",
  when_register_you_agree: "பதிவு செய்யும்போது நீங்கள் எங்களுடன் ஒப்புக்கொள்கிறீர்கள்",
  term_of_use: "பயன்பாட்டு விதிமுறைகள்",
  to: "எங்களுக்கு.",
  in_our: "எங்கள்",
  data_policy: "தரவு கொள்கைகள்",
  they_find_out: "அவர்கள் கண்டுபிடிக்கிறார்கள்,",
  we_provide_store_data: "நாங்கள் எவ்வாறு தகவலைச் சேகரிக்க, செயலாக்க மற்றும் சேமிக்கிறோம்.",
  leaving_company_text: "நீங்கள் உண்மையிலேயே நிறுவனத்தை விட்டு வெளியேற விரும்புகிறீர்களா? நிறுவனத்தை விட்டு வெளியேறும்போது நீங்கள் அனைத்து தொடர்புடைய திட்டங்கள் மற்றும் அரட்டை குழுக்களையும் விட்டு வெளியேறுகிறீர்கள். நீங்கள் எந்த நேரத்திலும் மற்றொரு நிறுவனத்துடன் இந்த திட்டங்களில் மீண்டும் சேரலாம்.",
  delete_profile_text: "நீங்கள் உண்மையிலேயே உங்கள் சுயவிவரத்தை நீக்க விரும்புகிறீர்களா? நீங்கள் உங்கள் சுயவிவரத்தை நீக்கும்போது நிறுவனங்கள், திட்டங்கள் மற்றும் அரட்டைகளுடனான அனைத்து இணைப்புகளும் அகற்றப்படும். நீங்கள் எந்த நேரத்திலும் புதிய சுயவிவரத்தை உருவாக்கலாம்.",
  confirm: "உறுதிப்படுத்தவும்",
  reject: "நிராகரிக்கவும்",
  requet_to_leave: "வெளியேறுவதற்கான கோரிக்கை",
  choose: "தேர்ந்தெடுக்கவும்",
  your_add_member: "உறுப்பினரைச் சேர்க்கவும்",
  if_you: "நீங்கள் என்றால்",
  can_not_find: "இங்கே உங்கள் தொடர்பைக் கண்டுபிடிக்க முடியாது.",
  please_wait: "தயவுசெய்து காத்திருக்கவும்..",
  imprint_gtc: "அச்சு/விதிமுறைகள்",
  register_confirm_popup: "உள்நுழைவதற்கு முன் உங்கள் Kjuup மின்னஞ்சலை உறுதிப்படுத்தவும். உறுதிப்படுத்தும் இணைப்பை அனுப்பியுள்ளோம். தெரியவில்லை என்றால் ஸ்பாம் கோப்புறையையும் பார்க்கவும்.",
  PENDING_GROUP_USER: "திட்டத்திற்கான அழைப்பு உறுதிப்படுத்தப்பட்ட பிறகே செய்திகளைப் பெறும். திட்டத்திற்கான அழைப்பு உறுதிப்படுத்தப்பட்டவுடன் கூடுதல் செய்தி தோன்றும்.",
  PENDING: "திட்டத்திற்கான அழைப்பு உறுதிப்படுத்தல் நிலுவையில்",
  denied_group_chat: " திட்ட அழைப்பை நிராகரித்து இந்த குழுவை விட்டு வெளியேறியுள்ளது.",
  joined_group_chat: " இந்த குழுவில் சேர்ந்துள்ளது",
  you_joined_group_chat: "நீங்கள் இந்த குழுவில் சேர்ந்துள்ளீர்கள்.",
  Others: "மற்றவை",
  LEFT_GROUP: "இந்த அரட்டை குழுவை விட்டு வெளியேறியுள்ளது.",
  YOU_LEFT_GROUP: "இந்த அரட்டை குழுவை விட்டு வெளியேறியுள்ளது.",
  days: "நாட்கள்",
  day: "நாள்",
  hour: "மணி",
  hide_project: "திட்டத்தை மறைக்கவும்",
  hide_project_popup_text: "நீங்கள் திட்டங்களை மறைத்தால், அவை Kjuup-இல் கண்டறிய முடியாது. திட்டத்தின் உறுப்பினர்கள் மட்டுமே புதிய பயனர்களை திட்டத்திற்கு அழைக்க முடியும்.",
  branch: "கிளை",
  photo_video_media_lib: "படம் - வீடியோ ஊடக நூலகம்",
  document: "ஆவணம்",
  location_meeting: "இடம் / கூட்டம்",
  all_member_of_project: "திட்டத்தின் அனைத்து உறுப்பினர்கள்",
  pending_request: "நிலுவையில் உள்ள திட்டக் கோரிக்கைகள்",
  no_pending_request: "நிலுவையில் உள்ள கோரிக்கைகள் எதுவும் கிடைக்கவில்லை!",
  news_feed: "செய்தி-ஊட்டம்",
  user_info: "குழு தகவல்",
  leave_project: "திட்டத்தை விட்டு வெளியேறு",
  media_link_docs: "கோப்புகள்",
  search_chat: "அரட்டையைத் தேடுங்கள்",
  export_chat_group: "கடந்த மாதத்திலிருந்து அரட்டை குழு தரவை ஏற்றுமதி செய்யவும்",
  request_complete_chat_history: "முழு அரட்டை வரலாற்றைக் கோரவும்",
  leave_chat_group: "அரட்டை குழுவை விட்டு வெளியேறு",
  add_user_project: "பயனரைச் சேர்க்கவும்",
  me: "நான்",
  max_open_one_to_one: "தற்போது அதிகபட்சம் 2 ஒன்றுக்கு ஒன்று அரட்டைகள் கீழ் மற்றும் மேல் பிரிவில் இணையாக திறக்கப்படலாம். மொத்தத்தில் அதிகபட்சம் 4 ஒன்றுக்கு ஒன்று அரட்டைகள் சாத்தியமாகும்.",
  are_you_sure_you_want_leave_chat: "நீங்கள் உண்மையிலேயே இந்த அரட்டை குழுவை விட்டு வெளியேற விரும்புகிறீர்களா?",
  create_group: "குழுவை உருவாக்கவும்",
  adding_members: "உறுப்பினர்களைச் சேர்க்கிறது...",
  creating_the_chat: "அரட்டையை உருவாக்குகிறது...",
  finishing_setup: "நிறைவு செய்கிறது...",
  group_name: "குழு பெயர்",
  by: "மூலம்:",
  mandetory: "*கட்டாய",
  delteed: "தனது சுயவிவரத்தை நீக்கி அரட்டை குழுவை விட்டு வெளியேறியுள்ளது.",
  deleted_direct: "தனது சுயவிவரத்தை நீக்கி அரட்டையை விட்டு வெளியேறியுள்ளது.",
  unhidden_message: "நீங்கள் திட்டங்களின் மறைப்பை நீக்கினால், Kjuup-இன் அனைத்து உறுப்பினர்களாலும் அவை கண்டறியப்படலாம்.",
  account_deleted: "கணக்கு நீக்கப்பட்டது.",
  refuse_company: "நீங்கள் உண்மையிலேயே நிறுவன அழைப்பை நிராகரிக்க விரும்புகிறீர்களா?",
  follow_additional: "கூடுதல் பயனர்களைப் பின்தொடரவும்",
  f_add: "நேரடி செய்திகளுக்கு அவர்களைக் கிடைக்கச் செய்ய Kjuup-இன் கூடுதல் பயனர்களைப் பின்தொடரவும்.",
  c_inv: "நிறுவன அழைப்பு(கள்)",
  invited_o_Company: "நீங்கள் நிறுவனத்தில் சேர அழைக்கப்பட்டுள்ளீர்கள்",
  refuse_companyX: "நீங்கள் உண்மையிலேயே நிறுவன கோரிக்கையை நிராகரிக்க விரும்புகிறீர்களா?",
  a_Da: "கணக்கு செயலிழக்கப்பட்டது.",
  has_deactivated: "தனது சுயவிவரத்தை செயலிழக்கச் செய்துள்ளது.",
  reactive: "தனது சுயவிவரத்தை மீண்டும் செயல்படுத்தியுள்ளது.",
  juup_note: "*பயனர் பெயருடன் பதிவு Kjuup+ உறுப்பினர்களுக்கு மட்டுமே கிடைக்கும்",
  username: "பயனர் பெயர்*",
  email_username: "மின்னஞ்சல்/பயனர் பெயர்*",
  sPinText: "தயவுசெய்து 6-இலக்க பாதுகாப்பு PIN வழங்கவும். உங்கள் கடவுச்சொல்லை மறந்துவிட்டால் இந்த PIN தேவைப்படும் மற்றும் உங்கள் கணக்கை உறுதிப்படுத்த இது கட்டாயமாகும்.",
  DeleteKjuupPlusText: "நீங்கள் உண்மையிலேயே உங்கள் சுயவிவரத்தை நீக்க விரும்புகிறீர்களா? நீங்கள் உங்கள் சுயவிவரத்தை நீக்கும்போது நிறுவனங்கள், திட்டங்கள் மற்றும் அரட்டைகளுடனான அனைத்து இணைப்புகளும் அகற்றப்படும்.\n\nகணக்கு நீக்கலுக்குப் பிறகு 48 மணி நேரத்திற்குள் நீங்கள் பயனர் பெயர், கடவுச்சொல் மற்றும் PIN உடன் உள்நுழைந்து உங்கள் கணக்கை மீண்டும் செயல்படுத்தலாம்.",
  reactive_text: "உங்கள் கணக்கு நீக்கப்பட்டது. தயவுசெய்து உங்கள் கணக்கை மீண்டும் செயல்படுத்த மீண்டும் செயல்படுத்தவும் என்பதைக் கிளிக் செய்யவும்.",
  rac: "மீண்டும் செயல்படுத்தவும்",
  ac_ss: "கணக்கு வெற்றிகரமாக மீண்டும் செயல்படுத்தப்பட்டது.",
  not_valid_pin: "PIN தவறானது",
  only_for_kjuup: "*பயனர் பெயர் மற்றும் PIN மூலம் கடவுச்சொல் மீட்டமைப்பு Kjuup+ உறுப்பினர்களுக்கு மட்டுமே கிடைக்கும்.",
  resetPIN: "PIN-ஐ மீட்டமைக்கவும்",
  enter_current_pin: "தயவுசெய்து உங்கள் தற்போதைய PIN-ஐ உள்ளிடவும்",
  enter_new: "புதிய PIN-ஐ உள்ளிடவும்",
  pin_to_confirm: "தயவுசெய்து உறுதிப்படுத்த PIN வழங்கவும்.",
  change_username: "பயனர் பெயரை மீட்டமைக்கவும்",
  pp_not_match: "கடவுச்சொல் - மற்றும் உறுதிப்படுத்தும் கடவுச்சொல் பொருந்தவில்லை",
  reactive_itself: "நீங்கள் உங்கள் சுயவிவரத்தை மீண்டும் செயல்படுத்தியுள்ளீர்கள்.",
  has_deactivated_itself: "நீங்கள் உங்கள் சுயவிவரத்தை செயலிழக்கச் செய்துள்ளீர்கள்.",
  more_than_two: "தற்போது நேரடி செய்திகள் 2 பயனர்களுடன் மட்டுமே இணையாக செய்ய முடியும்.",
  Chats: "நேரடி செய்திகள்",
  only_in_mobileL: "சொந்த வீடியோக்கள் தற்போது மொபைல் பயன்பாட்டின் மூலம் மட்டுமே பதிவேற்றம் செய்யப்பட்டு இடுகையிடப்படலாம். தயவுசெய்து Youtube மற்றும் Vimeo-இன் வீடியோ இணைப்புகளைப் பயன்படுத்தவும்.",
  register_pin_text: "தயவுசெய்து உங்கள் தனிப்பட்ட 6-இலக்க PIN-ஐத் தேர்ந்தெடுக்கவும். கணக்கு மீட்டமைப்பு செயல்பாடுகளை இயக்க இந்த PIN தேவைப்படும்.",
  internal_project: "உள்",
  external_projects: "வெளி",
  in_deacticted: "உள் பிரிவு செயலிழக்கப்பட்டது.",
  create_article: "கட்டுரையை உருவாக்கவும்",
  new_article_selection: "வெளி செய்தி-ஊட்டத்திற்கான கட்டுரையை உருவாக்கவும்",
  new_article_selection_internal: "உள் கட்டுரையை உருவாக்கவும்",
  active_trans_title: "தன்னியக்க மொழிபெயர்ப்பை இயக்கவா?",
  active_trans: "இயக்கப்படும்போது, வரும் அனைத்து அரட்டை செய்திகளும் நீங்கள் தேர்ந்தெடுத்த பயன்பாட்டு மொழியில் மொழிபெயர்க்கப்படும்.",
  disable_trans: "நீங்கள் உண்மையிலேயே தன்னியக்க மொழிபெயர்ப்பை செயலிழக்க விரும்புகிறீர்களா?",
  allow_access_chat: "முழு அரட்டை வரலாற்றைக் காட்டவும்",
  toggle_chat_history_on: "நீங்கள் உண்மையிலேயே பயனர் முழு அரட்டை வரலாற்றைப் பார்க்க விரும்புகிறீர்களா?",
  toggle_chat_history_off: "நீங்கள் உண்மையிலேயே பயனர் அரட்டையில் சேரும் புள்ளியிலிருந்து அரட்டை வரலாற்றை மட்டுமே பார்க்க விரும்புகிறீர்களா?",
  check_selected_settings: "தயவுசெய்து தேர்ந்தெடுக்கப்பட்ட அனைத்து பயனர்களுக்கும் அரட்டை வரலாறு அமைப்புகளைச் சரிபார்க்கவும்!",
  chat_from_start_have: "நீங்கள் இந்த குழுவில் சேர்ந்துள்ளீர்கள். அரட்டை வரலாறு பகிரப்பட்டது.",
  chat_from_start_has: "இந்த குழுவில் சேர்ந்துள்ளது. அரட்டை வரலாறு பகிரப்பட்டது.",
  Address: "முகவரி",
  read_by: "படித்தவர்",
  deliver_to: "வழங்கப்பட்டது",
  remaining: "மீதமுள்ள",
  message_info: "செய்தி தகவல்",
  request_to_join_only: "சேர்வதற்கான கோரிக்கை",
  unfollow: "பின்தொடர்வதை நிறுத்தவும்",
  company_username: "பயனர் பெயர்",
  month: ["ஜன", "பிப்", "மார்", "ஏப்", "மே", "ஜூன்", "ஜூலை", "ஆக", "செப்", "அக்", "நவ", "டிச"],
  remove_my_admin_right: "எனது நிர்வாக உரிமைகளை அகற்றவும்",
  makeEmp: "நீங்கள் உண்மையிலேயே பயனரிடமிருந்து நிறுவன நிர்வாக உரிமைகளை அகற்ற விரும்புகிறீர்களா?",
  remove_my_self: "நீங்கள் உண்மையிலேயே உங்கள் கணக்கிலிருந்து நிறுவன நிர்வாக உரிமைகளை அகற்ற விரும்புகிறீர்களா?",
  makeAdmin: "நீங்கள் உண்மையிலேயே பயனருக்கு நிறுவன நிர்வாக உரிமைகளை வழங்க விரும்புகிறீர்களா?",
  remove_member: "உறுப்பினரை அகற்றவும்",
  remove_following_confirm: "நீங்கள் உண்மையிலேயே {name} ஐ பின்தொடர்பவர்கள் பட்டியலிலிருந்து அகற்ற விரும்புகிறீர்களா?",
  remove_follower_confirm: "நீங்கள் உண்மையிலேயே {name} ஐ உங்களைப் பின்தொடர்பவர்கள் பட்டியலிலிருந்து அகற்ற விரும்புகிறீர்களா? அகற்றினால் அவருக்கு அறிவிக்கப்பட மாட்டார்.",
  do_you_really_want_to_remove: "நீங்கள் உண்மையிலேயே நிறுவனத்திலிருந்து பயனர் பெயரை அகற்ற விரும்புகிறீர்களா?",
  invite_all: "நிறுவனத்தின் அனைத்து உறுப்பினர்களையும் அழைக்கவும்",
  invite_all_members: "அனைத்து உறுப்பினர்களையும் அழைக்கவும்",
  mems: "மற்ற அனைத்து உறுப்பினர்கள்",
  dep_loc: "துறை/இடம்/குழு",
  depAdmin: "துறை நிர்வாகி",
  add_remove_admin: "நிறுவன நிர்வாகி பதவியைச் சேர்க்கவும்/அகற்றவும்",
  add_remove_dep_admin: "துறை நிர்வாகி பதவியைச் சேர்க்கவும்/அகற்றவும்",
  remove_employees_dept: "இலிருந்து ஊழியர்களை அகற்றவும்",
  want_to_join_dep: "பயனர் பெயர் நிறுவன companyname-இன் துறை/இடம்/குழு depname-இல் சேர விரும்புகிறது.",
  you_invited: "நீங்கள் நிறுவன companyname-இன் துறை/இடம்/குழு depname-இல் சேர அழைக்கப்பட்டுள்ளீர்கள்.",
  dep_remove: "நீங்கள் உண்மையிலேயே பயனரிடமிருந்து துறை அல்லது இடத்திற்கான நிர்வாக உரிமைகளை அகற்ற விரும்புகிறீர்களா?",
  add_dep: "நீங்கள் உண்மையிலேயே பயனருக்கு துறை அல்லது இடத்திற்கான நிர்வாக உரிமைகளை வழங்க விரும்புகிறீர்களா?",
  my_self_dep_remove: "நீங்கள் உண்மையிலேயே உங்கள் கணக்கிலிருந்து துறை நிர்வாக உரிமைகளை அகற்ற விரும்புகிறீர்களா?",
  member: "உறுப்பினர்",
  admin: "நிர்வாகி",
  remove_project_admin: "நீங்கள் உண்மையிலேயே திட்டத்திலிருந்து உறுப்பினரை அகற்ற விரும்புகிறீர்களா?",
  remove_my_self_project: "நீங்கள் உண்மையிலேயே நிர்வாக உரிமைகளை அகற்ற விரும்புகிறீர்களா?",
  remove_member_admin_right: "நீங்கள் உண்மையிலேயே பயனரிடமிருந்து நிர்வாக உரிமைகளை அகற்ற விரும்புகிறீர்களா?",
  add_member_admin_right: "நீங்கள் உண்மையிலேயே பயனருக்கு நிர்வாக உரிமைகளைச் சேர்க்க விரும்புகிறீர்களா?",
  add_remove_Poss: "நிர்வாகி பதவியைச் சேர்க்கவும்/அகற்றவும்",
  forward: "முன்னனுப்பவும்",
  edit: "திருத்தவும்",
  only_kjuup_plus_can: "Kjuup+ நிறுவனங்கள் மட்டுமே கட்டுரைகளை இடுகையிட முடியும்.",
  add_images: "படத்தைச் சேர்க்கவும்",
  request_confirmation: 'நிலுவையில் உள்ள திட்ட அழைப்புகள்',
  Activity: "செயல்பாடு",
  latest_messages: "சமீபத்திய செய்திகள்",
  hours: "மணிகள்",
  minute: "நிமிடங்கள்",
  seconds: "வினாடிகள்",
  days: "நாட்கள்",
  yesterday: "நேற்று",
  last_week: "கடந்த வாரம்",
  next_week: "அடுத்த வாரம்",
  Last_month: "கடந்த மாதம்",
  All: "அனைத்தும்",
  register_plus: "பதிவு பிளஸ்",
  select_files: "கோப்புகளைத் தேர்ந்தெடுக்கவும்",
  monthsFullName: ["ஜனவரி", "பிப்ரவரி", "மார்ச்", "ஏப்ரல்", "மே", "ஜூன்", "ஜூலை", "ஆகஸ்ட்", "செப்டம்பர்", "அக்டோபர்", "நவம்பர்", "டிசம்பர்"],
  company_deploc_receivers_message: "Kjuup-இல் நிறுவன company name-இன் துறைக்கான அழைப்பு இணைப்பு. தயவுசெய்து Kjuup-க்கு பதிவு செய்ய மற்றும் நிறுவன company name-இல் சேர இணைப்பைக் கிளிக் செய்யவும்.",
  no_news: "செய்திகள் எதுவும் கிடைக்கவில்லை",
  reminder: "நினைவூட்டல்",
  np_reminder: "ToDo-கள் இல்லை",
  move_to_reminder: "ToDo-க்கு நகர்த்தவும்",
  remove_reminder: "நீங்கள் உண்மையிலேயே இந்த செய்தியை உங்கள் ToDo-களின் பட்டியலிலிருந்து அகற்ற விரும்புகிறீர்களா?",
  remove_all_reminder: "அனைத்து ToDo-களையும் அகற்றவும்",
  remove_all_confirm: "நீங்கள் உண்மையிலேயே அனைத்து செய்திகளையும் உங்கள் ToDo-களின் பட்டியலிலிருந்து அகற்ற விரும்புகிறீர்களா?",
  remove_from_reminder: "நினைவூட்டலிலிருந்து அகற்றவும்",
  prevent_email: "மின்னஞ்சலை பயனர் பெயராகப் பயன்படுத்த முடியாது.",
  allow_noti: "தயவுசெய்து அறிவிப்புகளை அனுமதிக்கவும்.",
  join_cap: "சேருங்கள்",
  pass_minimum: "**கடவுச்சொல்லுக்கு சிறிய எழுத்து, பெரிய எழுத்து, எண் மற்றும் சிறப்பு எழுத்து உட்பட 12 எழுத்துக்கள் தேவை.",
  pass_error: "தயவுசெய்து கடவுச்சொல் தேவைகளைச் சரிபார்க்கவும்",
  people_that_like_article: "கட்டுரையை விரும்பியவர்கள்.",
  people_who_like_article: "உங்கள் கட்டுரையை விரும்பியவர்கள்.",
  message_delete: "இந்த செய்தி நீக்கப்பட்டது.",
  message_edited: "திருத்தப்பட்டது",
  edit_message: "செய்தியைத் திருத்து",
  edit_window_expired: "செய்திகளை அனுப்பிய 10 நிமிடங்களுக்குள் மட்டுமே திருத்த முடியும்.",
  message_edit_save: "சேமி",
  copy: "நகலெடு",
  bookmark: "புக்மார்க்",
  add_reaction: "எதிர்வினை சேர்",
  delete_message: "செய்தியை நீக்கு",
  more_options: "மேலும் விருப்பங்கள்",
  info: "தகவல்",
  link_invite: "இணைப்பு மூலம் அழைக்கவும்",
  ll_nkk: "Kjuup-க்கு அழைக்கவும்",
  selected: "தேர்ந்தெடுக்கப்பட்டது",
  is_active: "செயலில்",
  inactive: "செயலற்ற",
  last_online: "கடைசியாக ஆன்லைனில் {{when}}",
  remove_user_l: "அகற்றவும்",
  link_expire: "உருவாக்கப்பட்ட ஒவ்வொரு இணைப்பும் 72 மணி நேரத்திற்கு செல்லுபடியாகும்.",
  company_language: "நிறுவன மொழி",
  company_language_info: "மொழி தேர்வு நிறுவனம் தொடர்பான அனைத்து மின்னஞ்சல் உறுதிப்படுத்தல்களுக்கும் பயன்படுத்தப்படும்.",
  s_image: "படம்",
  m_image: "படங்கள்",
  removeMsg: "அகற்ற தட்டவும்",
  block: 'தடுக்கவும்',
  unblock: 'தடைநீக்கவும்',
  blocks: 'நீங்கள் உண்மையிலேயே இந்த பயனரைத் தடுக்க விரும்புகிறீர்களா?',
  unblocks: 'நீங்கள் உண்மையிலேயே இந்த பயனரின் தடையை நீக்க விரும்புகிறீர்களா?',
  bolcked_click_un_block: 'நீங்கள் இந்த தொடர்பைத் தடுத்துள்ளீர்கள். தடையை அகற்ற இங்கே கிளிக் செய்யவும்.',
  you_have_unblocked: 'நீங்கள் இந்த தொடர்பின் தடையை நீக்கியுள்ளீர்கள்.',
  you_have_blocked: 'நீங்கள் இந்த தொடர்பைத் தடுத்துள்ளீர்கள்.',
  unblock_to_send: 'செய்தி அனுப்ப பயனரின் தடையை நீக்கவும்.',
  pilot_text: "கட்டுமான தலைப்புகளுக்கான சிறப்பு AI",
  startup_screen_label: "தொடக்கத் திரை",
  startup_screen_info: "Kjuup தொடங்கும் போது எந்தத் திரை திறக்க வேண்டும் என்பதைத் தேர்ந்தெடுக்கவும்.",
  startup_screen_feed: "Home",
  startup_screen_messages: "செய்திகள்",
  startup_screen_saved: "தொடக்கத் திரை புதுப்பிக்கப்பட்டது",
email_on: "மின்னஞ்சல் அறிவிப்பு அரட்டைகள்",
  email_on_grp: "மின்னஞ்சல் அறிவிப்பு",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "இந்த திட்டத்திற்கான மின்னஞ்சல் அறிவிப்புகளை இயக்கவும் அல்லது செயலிழக்கவும். இந்த விருப்பம் தனிப்பட்ட அமைப்புகள் மூலம் \"மின்னஞ்சல் அறிவிப்பு அரட்டைகள்\" இயக்கப்பட்டால் மட்டுமே கிடைக்கும்.",
  todo_notification_info: "உங்களுக்கு புதிய பணி ஒதுக்கப்படும் ஒவ்வொரு முறையும் உங்களுக்கு அறிவிக்கப்படும்.",
  info_val: "புதிய அரட்டைச் செய்தி குறுகிய நேரத்தில் படிக்கப்படாவிட்டால் உங்களுக்கு மின்னஞ்சல் வரும். குறிப்பிட்ட திட்டங்கள் அல்லது அரட்டைகளுக்கு அவற்றின் அமைப்புகளில் அல்லது அரட்டை குழு தகவலில் இதை முடக்கலாம்.",
  email_groups: "இந்த அரட்டைக்கான மின்னஞ்சல் அறிவிப்புகளை இயக்கவும் அல்லது செயலிழக்கவும். இந்த விருப்பம் தனிப்பட்ட மற்றும் திட்ட அமைப்புகள் மூலம் \"மின்னஞ்சல் அறிவிப்பு அரட்டைகள்\" இயக்கப்பட்டால் மட்டுமே கிடைக்கும்.",
  add_update_email: "மின்னஞ்சலைச் சேர்க்கவும்/புதுப்பிக்கவும்",
  text_to_verifiy: "\"மின்னஞ்சல் அறிவிப்பு அரட்டைகள்\" விருப்பத்தை கோப்பில் சரிபார்க்கப்பட்ட மின்னஞ்சல் முகவரி இருந்தால் மட்டுமே இயக்க முடியும்.",
  stored_email: "சேமிக்கப்பட்ட மின்னஞ்சல்: ",
  verify_email: "உறுதிப்படுத்தல் நிலுவையில்!",
  join_call: "சேருங்கள்",
  call_is_started: "அழைப்பு தொடங்கியது",
  start_chat: "நேரடி-அரட்டையைத் தொடங்கவா?",
  project_rooms: "திட்டங்கள்",
  download_selected: "பதிவிறக்கவும்",
  add_employee_confirm: 'நீங்கள் உண்மையிலேயே இந்த பயனரை நிறுவனத்தில் சேர்க்க விரும்புகிறீர்களா?',
  invalid_deeplink: "தவறான deeplink URL. தேவையான அளவுருக்கள் காணவில்லை.",
  deeplink_error: "deeplink-ஐ செயலாக்க முடியவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
  reply: "பதிலளிக்கவும்",
  reply_enter: "பதிலை உள்ளிடவும்...",
  reply_sent_successfully: "பதில் வெற்றிகரமாக அனுப்பப்பட்டது",
  reply_failed: "பதில் அனுப்ப முடியவில்லை",
  reply_failed_generic: "பதில் அனுப்ப முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  replying_to_message: "செய்திக்கு பதிலளிக்கிறது",
  cancel_reply: "பதிலை ரத்துசெய்யவும்",
  voice_message: "குரல் செய்தி",
  send: "அனுப்பவும்",
  cancel: "ரத்துசெய்யவும்",
  type_your_reply: "உங்கள் பதிலைத் தட்டச்சு செய்யவும்...",
  suggested_replies: "பரிந்துரைக்கப்பட்ட பதில்கள்",
  suggestions_error: "பரிந்துரைகளை ஏற்ற முடியவில்லை",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "ஒரு கணம். உங்கள் உரை உங்களுக்காக தனிப்பட்ட முறையில் தயாரிக்கப்படுகிறது.",
  loading_chat_message: "அரட்டை ஏற்றுகிறது...",
  extracting_message: "செய்தியை பிரித்தெடுக்கிறது...",
  create_todo: "ToDo-ஐ உருவாக்கவும்",
  create_todo_confirmation: "இந்த செய்தியிலிருந்து ToDo-ஐ உருவாக்க விரும்புகிறீர்களா?",
  select_project_required: "தயவுசெய்து ஒரு திட்டம்/குழுவைத் தேர்ந்தெடுக்கவும்",
  only_assigned_can_change_status: "நியமிக்கப்பட்ட பயனர்கள் மட்டுமே நிலையை மாற்ற முடியும்",
  todo_summary: "சுருக்கம்",
  todo_summary_placeholder: "todo சுருக்கத்தை உள்ளிடவும்...",
  todo_date: "தேதி",
  todo_time: "நேரம்",
  todo_date_hint: "அசல் செய்தி தேதி/நேரத்தைப் பயன்படுத்த வெறுமையாக விடவும்",
  todo_created_success: "ToDo வெற்றிகரமாக உருவாக்கப்பட்டது",
  todo_creation_failed: "ToDo-ஐ உருவாக்க முடியவில்லை",
  create: "உருவாக்கவும்",
  image: "படம்",
  images: "படங்கள்",
  remove_all_images: "அனைத்து படங்களையும் அகற்றவும்",
  remove_image: "படத்தை அகற்றவும்",
  remove_document: "ஆவணத்தை அகற்றவும்",
  remove_recording: "பதிவை அகற்றவும்",
  play_recording: "பதிவை இயக்கவும்",
  upload_image: "படத்தைப் பதிவேற்றவும்",
  upload_document: "ஆவணத்தைப் பதிவேற்றவும்",
  record_audio: "ஒலியைப் பதிவு செய்யவும்",
  stop_recording: "பதிவை நிறுத்தவும்",
  stop_recording_text: "பதிவை நிறுத்தவும்",
  please_remove_current_attachment: "தயவுசெய்து தற்போதைய இணைப்பை அகற்றவும்",
  please_upload_image_file: "தயவுசெய்து சரியான படக் கோப்பைப் பதிவேற்றவும்",
  please_upload_valid_document: "தயவுசெய்து சரியான ஆவணக் கோப்பைப் பதிவேற்றவும்",
  searching_messages: "செய்திகளைத் தேடுகிறது...",
  loading_more: "மேலும் ஏற்றுகிறது...",
  loading_more_users: "மேலும் பயனர்களை ஏற்றுகிறது...",
  load_more_users: "மேலும் பயனர்களை ஏற்றவும்",
  no_more_users_to_load: "ஏற்றுவதற்கு மேலும் பயனர்கள் இல்லை",
  no_messages_found: "செய்திகள் எதுவும் கிடைக்கவில்லை",
  try_different_keyword: "வேறு முக்கிய வார்த்தையை முயற்சிக்கவும் அல்லது உங்கள் எழுத்துப்பிழையைச் சரிபார்க்கவும்.",
  search_messages: "செய்திகள், அரட்டை குழுக்கள், திட்டங்கள் மற்றும் பயனர்களைத் தேடுங்கள்...",
  todo: "ToDo",
  np_todo: "ToDo-கள் இல்லை",
  move_to_todo: "ToDo-ஆகச் சேமிக்கவும்",
  remove_todo: "நீங்கள் உண்மையிலேயே ToDo-ஐ அகற்ற விரும்புகிறீர்களா?",
  remove_all_todo: "அனைத்து ToDo-களையும் அகற்றவும்",
  remove_all_todo_confirm: "நீங்கள் உண்மையிலேயே அனைத்து ToDo-களையும் அகற்ற விரும்புகிறீர்களா?",
  add_to_todo: "ToDo-இல் சேர்க்கவும்",
  remove_from_todo: "ToDo-இலிருந்து அகற்றவும்",
  confirm: "உறுதிப்படுத்தவும்",
  ok: "சரி",
  read_more: "மேலும் படிக்கவும்",
  show_less: "குறைவாகக் காட்டவும்",
  show_more: "மேலும் காட்டு",
  audio: "ஒலி",
  video: "வீடியோ",
  notification_schedule: "அறிவிப்பு அட்டவணை",
  notification_schedule_desc: "நீங்கள் தேர்ந்தெடுக்கும் நேரங்களில் மட்டுமே புஷ் மற்றும் மின்னஞ்சல் அறிவிப்புகளைப் பெறுவீர்கள். அந்த நேரங்களுக்கு வெளியே அவை இடைநிறுத்தப்படும்.",
  learn_more: "மேலும் அறிக",
  allow_notifications: "அறிவிப்புகளை அனுமதிக்கவும்:",
  every_day: "ஒவ்வொரு நாளும்",
  weekdays: "வார நாட்கள் (திங்கள் முதல் வெள்ளி வரை)",
  custom: "தனிப்பயன்",
  monday: "திங்கள்",
  tuesday: "செவ்வாய்",
  wednesday: "புதன்",
  thursday: "வியாழன்",
  friday: "வெள்ளி",
  saturday: "சனி",
  sunday: "ஞாயிறு",
  to: "வரை",
  notification_settings: "அறிவிப்புகள்",
  notification_settings_saved: "அறிவிப்பு அமைப்புகள் வெற்றிகரமாக சேமிக்கப்பட்டன",
  notification_settings_error: "அறிவிப்பு அமைப்புகளைச் சேமிக்க முடியவில்லை",
  unavailability_note: "கிடைக்காமை குறிப்பு",
  unavailability_description: "அலுவலகத்தில் இல்லை என்ற குறிப்பை அமைக்கவும். செயலில் இருக்கும்போது, குறிப்பு உங்கள் அனைத்து அரட்டைகளிலும் மற்றவர்களுக்குக் காட்டப்படும் மற்றும் அறிவிப்புகள் இடைநிறுத்தப்படும்.",
  unavailability_start_date: "தொடக்க தேதி",
  unavailability_end_date: "முடிவு தேதி",
  unavailability_message: "செய்தி",
  unavailability_message_hint: "உங்கள் திரும்பும் தேதிக்கு {endDate} ஐ ஒதுக்கிடமாகப் பயன்படுத்தவும்.",
  unavailability_replacement: "மாற்று தொடர்பு",
  unavailability_replacement_placeholder: "அவசர கோரிக்கைகளுக்கு பயனர் ஐடியை உள்ளிடவும்",
  unavailability_replacement_current: "தற்போதைய மாற்று",
  unavailability_replacement_hint: "அமைக்கப்பட்டால், அவசர விஷயங்களுக்கு இந்த நபரைத் தொடர்பு கொள்ள ஒரு இணைப்பு உங்கள் கிடைக்காமை குறிப்பில் காட்டப்படும்.",
  unavailability_replacement_none: "மாற்று இல்லை (விருப்பத்தேர்வு)",
  unavailability_contact_urgent: "அவசர கோரிக்கைகளுக்கு தொடர்பு கொள்ளவும்",
  unavailability_default_message: "நான் தற்போது அலுவலகத்தில் இல்லை, Kjuup-ஐ அணுக இயலாது. {endDate} முதல் மீண்டும் கிடைப்பேன், அப்போது உங்களைத் தொடர்பு கொள்வேன்.",
  unavailability_save: "சேமி",
  unavailability_deactivate: "செயலிழக்கச் செய்",
  unavailability_active_until: "வரை செயலில்",
  unavailability_saved: "கிடைக்காமை குறிப்பு சேமிக்கப்பட்டது",
  unavailability_save_error: "கிடைக்காமை குறிப்பை சேமிக்க இயலவில்லை",
  unavailability_deactivated: "கிடைக்காமை குறிப்பு செயலிழக்கப்பட்டது",
  unavailability_end_date_required: "முடிவு தேதி அவசியம்",
  start_time_before_end_time: "முடிவு நேரத்திற்கு முன் தொடக்க நேரம் இருக்க வேண்டும்",
  loading: "ஏற்றுகிறது",
  disabled: "செயலிழக்கப்பட்டது",
  enable: "இயக்கவும்",
  disable: "செயலிழக்கவும்",
  forwarded: "முன்னனுப்பப்பட்டது",
  message_forwarded: "செய்தி முன்னனுப்பப்பட்டது!",
  schedule_article_post: "கட்டுரை இடுகையை அட்டவணையிடவும்",
  date: "தேதி",
  time: "நேரம்",
  scheduled_for_publication: "வெளியீட்டிற்கு அட்டவணையிடப்பட்டது",
  article_will_be_published_on: "கட்டுரை வெளியிடப்படும்:",
  reset_selection: "தேர்வை மீட்டமைக்கவும்",
  continue: "தொடரவும்",
  cancel: "ரத்துசெய்யவும்",
  error_loading_members: "உறுப்பினர்களை ஏற்றுவதில் பிழை",
  please_fill_all_fields: "தயவுசெய்து அனைத்து புலங்களையும் நிரப்பவும்",
  invalid_email: "தவறான மின்னஞ்சல் முகவரி",
  member_added_successfully: "உறுப்பினர் வெற்றிகரமாக சேர்க்கப்பட்டார்",
  error_onboarding_user: "பயனரைச் சேர்க்கும் பிழை",
  error_creating_chat: "அரட்டையை உருவாக்குவதில் பிழை",
  error_creating_group: "குழுவை உருவாக்குவதில் பிழை",
  new_group: "புதிய குழு",
  please_select_or_enter_group_name: "தயவுசெய்து ஒரு குழுவைத் தேர்ந்தெடுக்கவும் அல்லது குழு பெயரை உள்ளிடவும்",
  please_select_or_enter_room_name: "தயவுசெய்து ஒரு திட்டத்தைத் தேர்ந்தெடுக்கவும் அல்லது திட்டப் பெயரை உள்ளிடவும்",
  error_creating_room: "திட்டத்தை உருவாக்குவதில் பிழை",
  error_opening_chat: "அரட்டையைத் திறப்பதில் பிழை",
  privacy_modal_text: "திட்ட மேலாளருக்கு தொடர்புடைய தொழில்முறை உள்ளடக்கம் அரட்டையில் இல்லை என்றால் மட்டுமே \"தனிப்பட்ட\" என்பதைத் தேர்ந்தெடுக்கவும்.",
  not_private: "தனிப்பட்டதல்ல",
  private: "தனிப்பட்ட",
  error_loading_groups: "குழுக்களை ஏற்றுவதில் பிழை",
  automatic_chat_export: "தன்னியக்க அரட்டை ஏற்றுமதி",
  automatic_chat_export_info: "செயல்படுத்தலுக்குப் பிறகு, அரட்டை வரலாறு ஒவ்வொரு மாதமும் குறிப்பிடப்பட்ட மின்னஞ்சல் முகவரிக்கு தன்னியக்கமாக அனுப்பப்படும்.",
  automatic_chat_export_no_email: "தானியங்கி அரட்டை ஏற்றுமதியை இயக்க, முதலில் ஒரு மின்னஞ்சல் முகவரியைச் சேர்க்க வேண்டும். உங்கள் மின்னஞ்சல் முகவரியை தனிப்பட்ட அமைப்புகளில் சேர்க்கலாம்.",
  enter_email: "மின்னஞ்சலை உள்ளிடவும்",
  update: "புதுப்பிக்கவும்",
  confirm: "உறுதிப்படுத்தவும்",
  export_to_email: "ஏற்றுமதி பின்வரும் மின்னஞ்சலுக்குச் செல்லும்.",
  start_chat_button: "புதிய செய்தி",
  matching_existing_chats: "இருக்கும் அரட்டைகளைப் பொருத்துகிறது",
  subject: "பொருள்",
  add_subject: "பொருளைச் சேர்க்கவும்",
  chat_subject: "அரட்டை பொருள்:",
  set_project_room: "திட்டத்தை அமைக்கவும்",
  matching_existing_project_rooms: "இருக்கும் திட்டங்களைப் பொருத்துகிறது",
  name_project_room: "திட்டப் பெயர்",
  professional_or_private: "தொழில்முறை அல்லது தனிப்பட்ட",
  professional: "தொழில்முறை",
  privacy_modal_text_updated: "திட்ட மேலாளர்களுக்கு தொடர்புடைய தொழில்முறை உள்ளடக்கம் அரட்டையில் இல்லை என்றால் மட்டுமே \"தனிப்பட்ட\" என்பதைத் தேர்ந்தெடுக்கவும். தனிப்பட்ட அரட்டைகள் திட்ட மேலாளர்களுக்குத் தெரியாது.",
  create_internal_chat: "வெளி - அல்லது உள் அரட்டை?",
  internal_chat_description: "உங்கள் நிறுவனத்தின் ஊழியர்கள் மட்டுமே உள் அரட்டைகளில் சேர்க்கப்படலாம்.",
  yes: "ஆம்",
  no: "இல்லை",
  chat_is_being_created: "அரட்டை உருவாக்கப்படுகிறது...",
  discard_article_confirm: "இந்தக் கட்டுரையில் செய்த மாற்றங்களை நீங்கள் உண்மையிலேயே நிராகரிக்க விரும்புகிறீர்களா?",
  please_enter_article_title: "தயவுசெய்து முதலில் கட்டுரை தலைப்பை உள்ளிடவும்.",
  please_add_mandatory_fields: "தயவுசெய்து அனைத்து கட்டாய புலங்களையும் சேர்க்கவும்",
  product_label: "தயாரிப்பு:",
  no_companies_found: "நிறுவனங்கள் எதுவும் கிடைக்கவில்லை",
  visible_to_all_followers: "அனைத்து Kjuup உறுப்பினர்களுக்கும் தெரியும்",
  only_visible_to_employees: "ஊழியர்களுக்கு மட்டுமே தெரியும்",
  something_went_wrong: "ஏதோ தவறு நடந்தது, தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
  please_select_department: "தயவுசெய்து துறை/இடத்தைத் தேர்ந்தெடுக்கவும்",
  schedule: "அட்டவணை",
  please_select_future_date_time: "தயவுசெய்து கட்டுரையை அட்டவணையிட எதிர்கால தேதி மற்றும் நேரத்தைத் தேர்ந்தெடுக்கவும்.",
  please_select_different_date_time: "தயவுசெய்து கட்டுரையை அட்டவணையிட வேறு தேதி அல்லது நேரத்தைத் தேர்ந்தெடுக்கவும்.",
  please_select_later_time: "தயவுசெய்து இன்றைக்கு தற்போதைய நேரத்தை விட பிறகு ஒரு நேரத்தைத் தேர்ந்தெடுக்கவும்.",
  unpin_article: "கட்டுரையின் பினை நீக்கவும்",
  pin_article: "கட்டுரையைப் பினை செய்யவும்",
  and: "மற்றும்",
  others: "மற்றவை",
  at: "இல்",
  mute: "ஒலியை நிறுத்தவும்",
  unmute: "ஒலியை இயக்கவும்",
  chat_muted_successfully: "அரட்டை வெற்றிகரமாக ஒலியடக்கப்பட்டது",
  chat_unmuted_successfully: "அரட்டை வெற்றிகரமாக ஒலியடக்க நீக்கப்பட்டது",
  mute_chat_confirm: "நீங்கள் உண்மையிலேயே இந்த அரட்டையை ஒலியடக்க விரும்புகிறீர்களா? நீங்கள் இனி புதிய செய்திகளுக்கான அறிவிப்புகளைப் பெற மாட்டீர்கள்.",
  unmute_chat_confirm: "நீங்கள் உண்மையிலேயே இந்த அரட்டையின் ஒலியடக்கத்தை நீக்க விரும்புகிறீர்களா? நீங்கள் மீண்டும் புதிய செய்திகளுக்கான அறிவிப்புகளைப் பெறுவீர்கள்.",
  please_select_group_to_forward: "தயவுசெய்து செய்தியை முன்னனுப்ப குழுவைத் தேர்ந்தெடுக்கவும்",
  record_not_found: "பதிவு கிடைக்கவில்லை!",
  please_select_position: "தயவுசெய்து பதவியைத் தேர்ந்தெடுக்கவும்",
  delete_article_confirm: "நீங்கள் உண்மையிலேயே இந்த கட்டுரையை நீக்க விரும்புகிறீர்களா?",
  delete_company_service_confirm: "நீங்கள் உண்மையிலேயே நிறுவன சேவையை நீக்க விரும்புகிறீர்களா?",
  block_translation_confirm: "நீங்கள் உண்மையிலேயே நிறுவனத்தின் அனைத்து உறுப்பினர்களுக்கும் திட்டங்களில் தன்னியக்க மொழிபெயர்ப்பைத் தடுக்க விரும்புகிறீர்களா",
  unblock_translation_confirm: "நீங்கள் உண்மையிலேயே நிறுவனத்தின் அனைத்து உறுப்பினர்களுக்கும் திட்டங்களில் தன்னியக்க மொழிபெயர்ப்பின் தடையை நீக்க விரும்புகிறீர்களா",
  please_select_file: "தயவுசெய்து பதிவேற்ற கோப்பைத் தேர்ந்தெடுக்கவும்",
  role_in_building_industry: "கட்டுமானத் தொழிலில் பங்கு*",
  invalid_email_address: "தவறான மின்னஞ்சல் முகவரி",
  please_enter_password: "தயவுசெய்து கடவுச்சொல்லை உள்ளிடவும்",
  password_change_email_sent: "உங்கள் Kjuup மின்னஞ்சலுக்கு ஒரு மின்னஞ்சல் அனுப்பப்பட்டுள்ளது. மின்னஞ்சலில் உள்ள உறுதிப்படுத்தல் இணைப்பைக் கிளிக் செய்து உங்கள் புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்.",
  please_enter_username: "தயவுசெய்து பயனர் பெயரை உள்ளிடவும்",
  username_same_as_before: "பயனர் பெயர் முன்பு போலவே இருக்க முடியாது",
  profile_deleted_successfully: "சுயவிவரம் வெற்றிகரமாக நீக்கப்பட்டது",
  hardware_requirements: "வன்பொருள் தேவைகள்",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU வேகம் குறைந்தது 2GHz<br/>• Windows 7 அல்லது அதற்கு மேல் / அனைத்து macOS பதிப்புகள்",
  submitting: "சமர்ப்பிக்கிறது...",
  signing_in: "உள்நுழைகிறது...",
  please_enter_service_name: "தயவுசெய்து சேவை பெயரை உள்ளிடவும்",
  something_went_wrong_error: "ஆ! ஏதோ தவறு நடந்தது...",
  something_went_wrong_try_again: "மன்னிக்கவும், அங்கு ஏதோ தவறு நடந்தது. மீண்டும் முயற்சிக்கவும்",
  position_label: "பதவி:",
  loading_room: "திட்டம் ஏற்றுகிறது...",
  navigating_to_room: "திட்டத்திற்கு செல்கிறது",
  loading_chat: "அரட்டை ஏற்றுகிறது...",
  translate: "மொழிபெயர்க்கவும்",
  show_original: "அசலைக் காட்டவும்",
  saving: "சேமிக்கிறது...",
  language_selection_info: "மொழி தேர்வு நிறுவனம் தொடர்பான அனைத்து மின்னஞ்சல் உறுதிப்படுத்தல்களுக்கும் பயன்படுத்தப்படும்.",
  nav_call: "அழைப்பு",
  nav_home: "முகப்பு",
  nav_messages: "செய்திகள்",
  nav_todo: "பணிகள்",
  nav_rooms: "திட்டங்கள்",
  nav_all_rooms: "அனைத்து திட்டங்கள்",
  pinned_rooms_max: "நீங்கள் 10 திட்டங்கள் வரை பின் செய்யலாம்.",
  pinned_room_unpin: "பின் நீக்கு",
  pinned_rooms_drop: "விரைவு தேர்வுக்கு உங்கள் திட்டத்தை இங்கே இழுக்கவும்",
  nav_profile: "சுயவிவரம்",
  nav_company: "நிறுவனம்",
  nav_company_documents: "ஆவணங்கள்",
  nav_logout: "வெளியேறு",
  add_member_title: "உறுப்பினரைச் சேர்க்கவும்",
  continue_btn: "தொடரவும்",
  search_placeholder: "தேடு",
  no_members_found: "உறுப்பினர்கள் எவரும் கிடைக்கவில்லை",
  no_groups_found: "குழுக்கள் எதுவும் கிடைக்கவில்லை",
  no_rooms_found: "திட்டங்கள் எதுவும் கிடைக்கவில்லை",
  search_users_tab: "பயனர்கள்",
  search_documents_tab: "ஆவணங்கள்",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "கோப்புகள் இல்லை",
  no_documents_available: "No documents",
  searching_users: "பயனர்களைத் தேடுகிறது...",
  no_users_found: "பயனர்கள் எவரும் கிடைக்கவில்லை",
  search_emails_tab: "மின்னஞ்சல்",
  searching_emails: "மின்னஞ்சல்களைத் தேடுகிறது...",
  no_emails_found: "மின்னஞ்சல்கள் எதுவும் கிடைக்கவில்லை",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "பெயரில்லாத குழு",
  unnamed_room: "பெயரில்லாத திட்டம்",
  all_members: "அனைத்தும்",
  room_label: "திட்டம்:",
  subject_label: "பொருள்:",
  no_members: "உறுப்பினர்கள் இல்லை",
  creating_structure: "உங்கள் கட்டமைப்பை உருவாக்குகிறது",
  opening_chat: "அரட்டையைத் திறக்கிறது",
  please_wait: "தயவுசெய்து காத்திருக்கவும்...",
  loading_todo: "ToDo ஏற்றுகிறது...",
  task_updated: "பணி புதுப்பிக்கப்பட்டது",
  error_updating_task: "பணியைப் புதுப்பிக்கும் பிழை",
  task_deleted: "பணி நீக்கப்பட்டது",
  error_deleting_task: "பணியை நீக்கும் பிழை",
  delete_task_confirm: "நீங்கள் உண்மையிலேயே இந்த பணியை நீக்க விரும்புகிறீர்களா?",
  description_label: "விளக்கம்",
  description_placeholder: "விளக்கத்தை உள்ளிடவும்...",
  date_time_label: "தேதி & நேரம்",
  save_hint: "சேமிக்க Ctrl+Enter, ரத்துசெய்ய Esc",
  edit_label: "திருத்தவும்",
  delete_label: "நீக்கவும்",
  todo_list_title: "பணிகள்",
  tasks_count: "பணிகள்",
  search_placeholder_todo: "தேடு...",
  select_task_to_open_chat: "அரட்டையைத் திறக்க பணியைத் தேர்ந்தெடுக்கவும்",
  today: "இன்று",
  yesterday: "நேற்று",
  time_suffix: "",
  from_chat: "மூல ToDo",
  assigned_to: "ஒப்படைக்கப்பட்டது",
  assign_users: "பயனர்களை ஒப்படைக்கவும்",
  no_users_assigned: "பயனர்கள் எவரும் ஒப்படைக்கப்படவில்லை",
  assign: "ஒப்படைக்கவும்",
  assign_to: "ஒப்படைக்க...",
  navigate_to_chat: "அரட்டைக்குச் செல்லவும்",
  navigate_to_email: "மின்னஞ்சலுக்குச் செல்லவும்",
  show_original_message: "மூலத்தைக் காட்டவும்",
  hide_original_message: "மூலத்தை மறைக்கவும்",
  status_pending: "நிலுவையில்",
  status_in_progress: "நடந்து கொண்டிருக்கிறது",
  status_completed: "முடிக்கப்பட்டது",
  show: "காட்டவும்",
  close: "மூடு",
  status_confirmed: "[உறுதிப்படுத்தப்பட்டது]",
  log_todo_created: "ToDo [உருவாக்கப்பட்டது]",
  log_todo_confirmed: "ToDo [உறுதிப்படுத்தப்பட்டது]",
  log_todo_deleted: "ToDo [நீக்கப்பட்டது]",
  log_todo_updated: "ToDo [புதுப்பிக்கப்பட்டது]",
  log_description_updated: "[விளக்கம் புதுப்பிக்கப்பட்டது]",
  log_deadline_updated: "[காலக்கெடு புதுப்பிக்கப்பட்டது]",
  log_assigned_to: "[ஒப்படைக்கப்பட்டது] {name}",
  log_unassigned_from: "[ஒப்படைப்பு நீக்கப்பட்டது] {name}",
  log_assignment_added: "[ஒப்படைப்பு சேர்க்கப்பட்டது]: {name}",
  log_assignment_removed: "[ஒப்படைப்பு அகற்றப்பட்டது]: {name}",
  log_status_updated: "[நிலை மாற்றப்பட்டது] {from} [இலிருந்து] {to}",
  log_status_changed: "[நிலை மாற்றப்பட்டது]",
  log_status_changed_to: "[நிலை மாற்றப்பட்டது] {status}",
  log_changed_status_to: "[நிலை மாற்றப்பட்டது]:",
  log_for_user: "[பயனருக்கு]:",
  log_user_updated_status: "[பயனர் தங்கள் todo நிலையை புதுப்பித்தார்]",
  log_changed_date_to: "[தேதி மாற்றப்பட்டது]:",
  log_changed_description_to: "[விளக்கம் மாற்றப்பட்டது]:",
  log_moved_to: "[நகர்த்தப்பட்டது] {status}",
  todo_status_updated_from: "[இலிருந்து]",
  todo_status_updated_to: "[க்கு]",
  filter_pending: "நிலுவையில்",
  filter_confirmed: "உறுதிப்படுத்தப்பட்டது",
  filter_assigned_to_me: "என் பணிகள்",
  filter_assigned_by_me: "ஒப்படைக்கப்பட்டது",
  todo_project_label: "திட்டம்:",
  assigned_users: "ஒதுக்கப்பட்ட பயனர்கள்:",
  todo_chat_label: "அரட்டை:",
  history: "வரலாறு",
  todo_assigned_by: "ஒதுக்கியவர்:",
  todo_assigned_push: "ஒதுக்கப்பட்ட ToDo:",
  todo_assigned_push_empty: "உங்களுக்கு ஒரு புதிய ToDo ஒதுக்கப்பட்டுள்ளது.",
  search_groups: "குழுக்கள்",
  search_chat_groups: "அரட்டை குழுக்கள்",
  search_project_room: "திட்டம்",
  search_messages_tab: "செய்திகள்",
  searching_groups: "குழுக்களைத் தேடுகிறது...",
  searching_rooms: "திட்டங்களைத் தேடுகிறது...",
  no_groups_found: "குழுக்கள் எதுவும் கிடைக்கவில்லை",
  no_rooms_found: "திட்டங்கள் எதுவும் கிடைக்கவில்லை",
  create_poll: "Poll",
  poll_question_label: "QUESTION",
  poll_question_placeholder: "Ask a question",
  poll_options_label: "OPTIONS",
  poll_option: "Option",
  poll_add_option: "Add option",
  poll_allow_multiple: "Allow multiple answers",
  poll_multiple_allowed: "Select one or more options",
  poll_select_option: "Select one option",
  poll_view_votes: "View votes",
  poll_vote_singular: "vote",
  poll_vote_plural: "votes",
  poll_votes: "Poll votes",
  poll_no_votes_yet: "No votes yet",
  transcript_step_processing: "படியெடுப்பு நடைபெறுகிறது...",
  ai_transcript_tab: "AI-படியெடுப்பு",
  ai_transcript_info: "09.03.2026 க்குப் பிறகு உருவாக்கப்பட்ட குரல் செய்திகளுக்கு மட்டுமே கிடைக்கும்.",
  transcript_more: "...மேலும்",
  transcript_less: "...குறைவாக",
  ki_transcript_voice_message: "KI-குரல் செய்தி டிரான்ஸ்கிரிப்ட்",
  ki_image_analysis: "AI-இயக்கப்படும் படப் பகுப்பாய்வு",
  type_message: "ஒரு செய்தியை தட்டச்சு செய்யவும்",
  email_tab_messages: "செய்திகள்",
  email_tab_email: "மின்னஞ்சல்",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "மின்னஞ்சல் கணக்குகள்",
  email_connect_gmail: "Gmail இணைக்கவும்",
  email_connect_outlook: "Outlook இணைக்கவும்",
  email_no_accounts: "இணைக்கப்பட்ட மின்னஞ்சல் கணக்குகள் இல்லை",
  email_no_accounts_hint: "உங்கள் சுயவிவர அமைப்புகளில் மின்னஞ்சல் கணக்கை இணைக்கவும்",
  email_no_messages: "மின்னஞ்சல்கள் இல்லை",
  email_from: "இருந்து",
  email_to: "க்கு",
  email_subject: "பொருள்",
  email_disconnect: "துண்டிக்கவும்",
  email_disconnect_confirm: "இந்த மின்னஞ்சல் கணக்கை துண்டிக்க விரும்புகிறீர்களா? ஒத்திசைக்கப்பட்ட அனைத்து மின்னஞ்சல்களும் அகற்றப்படும்.",
  email_account_disconnected: "மின்னஞ்சல் கணக்கு வெற்றிகரமாக துண்டிக்கப்பட்டது",
  email_account_disconnect_failed: "கணக்கை துண்டிக்க இயலவில்லை",
  email_connecting: "இணைக்கிறது...",
  email_account_connected: "கணக்கு வெற்றிகரமாக இணைக்கப்பட்டது",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "அமைப்புகளுக்குச் செல்லுங்கள்",
  email_date: "தேதி",
  email_reply: "பதில்",
  email_forward: "முன்னனுப்பு",
  email_copy_text: "உரையை நகலெடு",
  email_text_copied: "நகலெடுக்கப்பட்டது!",
  email_text_copy_failed: "உரையை நகலெடுக்க முடியவில்லை.",
  email_delete: "நீக்கு",
  email_not_spam: "ஸ்பேம் அல்ல",
  email_not_spam_success: "மின்னஞ்சல் இன்பாக்ஸுக்கு நகர்த்தப்பட்டது.",
  email_not_spam_failed: "இன்பாக்ஸுக்கு நகர்த்த இயலவில்லை.",
  email_delete_confirm: "இந்த மின்னஞ்சலை நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
  email_delete_from_folder: "{folder} இலிருந்து நீக்க விரும்புகிறீர்களா?",
  email_delete_permanent_from_folder:
    "{folder} இலிருந்து நிரந்தரமாக நீக்க விரும்புகிறீர்களா? இந்த செயலை செயல்தவிர்க்க முடியாது.",
  email_save_draft_confirm: "இந்த மின்னஞ்சலை வரைவாக சேமிக்க வேண்டுமா?",
  email_save_draft: "வரைவு சேமி",
  email_discard: "நிராகரி",
  email_back_to_compose: "எழுதுவதற்குத் திரும்பு",
  email_draft_saved: "வரைவு சேமிக்கப்பட்டது.",
  email_draft_save_failed: "வரைவு சேமிக்க இயலவில்லை.",
  email_loading: "மின்னஞ்சல்கள் ஏற்றுகிறது...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Select",
  email_attachment_singular: "Attachment",
  email_attachment_plural: "Attachments",
  email_back: "Back",
  email_download: "Download",
  email_close: "Close",
  email_preview: "Preview",
  email_preview_not_available: "முன்னோட்டம் கிடைக்கவில்லை",
  email_preview_failed: "முன்னோட்டம் கிடைக்கவில்லை",
  select_attachments: "இணைப்புகளைத் தேர்ந்தெடுக்கவும்",
  email_loading_preview: "Loading preview...",
  email_mark_unread_failed: "email(s) could not be marked as unread.",
  email_delete_failed: "email(s) could not be deleted.",
  filter_all: "அனைத்தும்",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "நேரடி செய்திகள்",
  my_notes: "My Space",
  filter_internal_groups: "உள் குழு அரட்டைகள்",
  filter_external_groups: "வெளி குழு அரட்டைகள்",
  filter_group_chats: "குழு அரட்டைகள்",
  filter_groups_internal: "உள்",
  filter_groups_external: "வெளி",
  filter_unread_only: "படிக்காதவை மட்டும்",
  room_daily_briefing_info: "இயக்கப்பட்டால், தனிப்பட்ட அமைப்புகளில் குறிப்பிட்ட நேரத்தில் ஒவ்வொரு 24 மணிநேரமும் இந்த திட்டத்திற்கான அறிக்கை உருவாக்கப்படும் — ஆனால் அந்த காலத்தில் செயல்பாடு இருந்தால் மட்டுமே.",
  email_select_all: "அனைத்தையும் தேர்ந்தெடு",
  email_deselect_all: "அனைத்தையும் தேர்வு நீக்கு",
  email_reply_all: "அனைவருக்கும் பதிலளி",
  email_reply_placeholder: "உங்கள் பதிலை தட்டச்சு செய்யுங்கள்...",
  email_forward_placeholder: "ஒரு செய்தியைச் சேர்க்கவும்...",
  email_edit_draft: "வரைவை திருத்து",
  email_attach: "இணை",
  email_attachment_from_original: "அசல் செய்தியிலிருந்து",
  email_remove: "நீக்கு",
  email_drop_files: "இணைக்க கோப்புகளை விடுங்கள்",
  email_loading_attachments: "இணைப்புகள் ஏற்றப்படுகின்றன...",
  email_archive: "காப்பகம்",
  mark_unread: "படிக்காததாகக் குறி",
  mark_read: "படித்ததாகக் குறி",
  email_all_accounts: "அனைத்து கணக்குகள்",
  email_error: "பிழை",
  email_delete_email_failed: "மின்னஞ்சலை நீக்க முடியவில்லை.",
  enter_url: "URL ஐ உள்ளிடவும்",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'இப்போது சந்தா செய்யுங்கள்',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 மாதம் இலவச சோதனை',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'இன்று பணம் செலுத்த வேண்டாம். கட்டண சந்தா தொடங்கும் முன் கிரெடிட் கார்டு விவரங்கள் கேட்கப்படாது.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'அனைத்து மின்னஞ்சல் கணக்குகளையும் Kjuup-இல் நேரடியாக நிர்வகிக்கவும்',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI பதில்களை எழுதும் – நீங்கள் உறுதிப்படுத்தவும்',
  kjuup_io_feature_tasks: 'பணிகள் & நாட்காட்டி எப்போதும் தானாக புதுப்பிக்கப்படும்',
  kjuup_io_choose_plan: 'திட்டத்தைத் தேர்ந்தெடுக்கவும்',
  kjuup_io_plan_monthly: 'மாதாந்திர',
  kjuup_io_plan_yearly: 'ஆண்டுதோறும்',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe மூலம் பாதுகாக்கப்பட்டது · எப்போது வேண்டுமானாலும் ரத்து செய்யலாம்',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'கட்டணம் பெறப்பட்டது. உங்கள் சந்தா செயல்படுத்தப்படுகிறது…',
  kjuup_io_toast_activating_soon: 'கட்டணம் பெறப்பட்டது. உங்கள் சந்தா விரைவில் செயல்படுத்தப்படும்.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} மணிநேரம் மீதமுள்ளது',
  kjuup_io_trial_left_hour: '1 மணிநேரம் மீதமுள்ளது',
  kjuup_io_trial_left_minutes: '{count} நிமிடங்கள் மீதமுள்ளன',
  kjuup_io_trial_left_minute: '1 நிமிடம் மீதமுள்ளது',
  kjuup_io_trial_left_seconds: '{count} வினாடிகள் மீதமுள்ளன',
  kjuup_io_trial_left_second: '1 வினாடி மீதமுள்ளது',
  kjuup_io_trial_ending_now: 'உங்கள் சோதனைக் காலம் முடிவடைகிறது…',
  kjuup_io_request_timeout: 'இணைப்பு காலாவதியானது. மீண்டும் முயற்சிக்கவும்.',
  kjuup_io_info_days_free: '{days} நாட்கள் முழு இலவசம் – சந்தா சோதனைக்குப் பிறகே தொடங்கும்.',
  kjuup_io_discount_total: 'உங்கள் தள்ளுபடி: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'தனிப்பட்டது: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'மூடு',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'உங்கள் இலவச சோதனைக் காலம் முடிந்தது',
  kjuup_io_trial_ended_body: 'மின்னஞ்சல் மற்றும் பிற பிரீமியம் அம்சங்களைத் தொடர்ந்து பயன்படுத்த Kjuup.io-க்கு சந்தா செலுத்துங்கள்.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'உங்கள் இலவச சோதனைக் காலம் தொடங்கியது',
  kjuup_io_toast_trial_fail: 'இலவச சோதனைக் காலத்தைத் தொடங்க முடியவில்லை',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / மாதம்',
  kjuup_io_save_amount_year: 'ஆண்டுக்கு {price} சேமிக்கவும்',
  kjuup_io_billed_annually_amount: '{price} ஆண்டுக்கொருமுறை கட்டணம்',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'நீங்கள் பெறுவது:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'கிரெடிட் கார்டு தேவையில்லை – கட்டண விவரங்கள் இல்லாமல் உடனே தொடங்குங்கள்.',
  kjuup_io_info_cancel_anytime: 'எப்போதும் ரத்து செய்யலாம் – கடமை இல்லை, ஆபத்து இல்லை.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'பில்லிங் காலம்',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'கட்டண முறை சேமிக்கப்பட்டது. சோதனைக் காலம் முடிந்ததும் கட்டணம் வசூலிக்கப்படும்.',
  calendar_sync_info: 'அனைத்து Kjuup ToDo-க்களையும் உங்கள் நாட்காட்டியுடன் தானாக ஒத்திசைக்கவும்.',
  calendar_no_accounts: 'இதுவரை எந்த நாட்காட்டியும் இணைக்கப்படவில்லை.',
  article_new_badge: 'புதியது',
  article_new_posts: '{0} புதிய இடுகைகள்',
  documents: 'ஆவணங்கள்',
  add_documents: 'ஆவணங்களைச் சேர்க்கவும்',
  no_preview_available: 'முன்னோட்டம் கிடைக்கவில்லை',
  no_preview_hint: 'இந்த வகை கோப்பை முன்னோட்டமிட முடியாது, ஆனால் அது அனுப்பப்படும்.',
  max_documents_reached: 'ஒரே நேரத்தில் அதிகபட்சம் 10 ஆவணங்களை இணைக்கலாம்.',
  open_file: 'கோப்பைத் திற',
  twofa_title: 'இரு காரணி அங்கீகாரம்',
  twofa_method_totp: 'அங்கீகார செயலி',
  twofa_method_sms: 'உரை செய்தி',
  twofa_method_email: 'மின்னஞ்சல்',
  twofa_enter_app: 'அங்கீகார செயலியிலிருந்து 6 இலக்க குறியீட்டை உள்ளிடவும்.',
  twofa_enter_sms: 'SMS மூலம் அனுப்பிய 6 இலக்க குறியீட்டை உள்ளிடவும்.',
  twofa_enter_email: 'மின்னஞ்சலுக்கு அனுப்பிய 6 இலக்க குறியீட்டை உள்ளிடவும்.',
  twofa_resend: 'குறியீட்டை மீண்டும் அனுப்பு',
  twofa_try_another: 'வேறொரு முறையை முயற்சிக்கவும்',
  twofa_remember_device: 'இந்த சாதனத்தில் 30 நாட்கள் கேட்க வேண்டாம்',
  twofa_sent: 'நாங்கள் ஒரு குறியீட்டை அனுப்பியுள்ளோம்.',
  twofa_invalid_code: 'இந்த குறியீடு தவறு. மீண்டும் முயற்சிக்கவும்.',
  twofa_something_wrong: 'ஏதோ தவறாகிவிட்டது. மீண்டும் முயற்சிக்கவும்.',
  twofa_method_unavailable: 'இந்த சரிபார்ப்பு முறை கிடைக்கவில்லை.',
  twofa_on_desc: 'இரு காரணி அங்கீகாரம் இயக்கத்தில் உள்ளது. ஒவ்வொரு உள்நுழைவிலும் குறியீடு தேவை.',
  twofa_off_desc: 'கடவுச்சொல்லுக்குப் பிறகு இரண்டாம் படி சேர்க்கவும். அங்கீகார செயலிகள் மிகவும் பாதுகாப்பானவை.',
  twofa_methods: 'முறைகள்',
  twofa_on: 'இயக்கம்',
  twofa_add: 'சேர்',
  twofa_default_method: 'இயல்புநிலை முறை',
  twofa_default: 'இயல்புநிலை',
  twofa_turn_off: 'அணை',
  twofa_disable_hint: 'இரு காரணி அங்கீகாரத்தை அணைக்க கடவுச்சொல்லும் தற்போதைய குறியீடும் உள்ளிடவும்.',
  twofa_disable_need: 'கடவுச்சொல்லும் சரிபார்ப்பு குறியீடும் உள்ளிடவும்.',
  twofa_code_placeholder: '6 இலக்க குறியீடு அல்லது காப்பு குறியீடு',
  twofa_send_code: 'குறியீட்டை அனுப்பு',
  twofa_primary_updated: 'இயல்புநிலை முறை புதுப்பிக்கப்பட்டது.',
  twofa_disabled: 'இரு காரணி அங்கீகாரம் இப்போது அணைக்கப்பட்டது.',
  twofa_enabled: 'இரு காரணி அங்கீகாரம் இப்போது இயக்கப்பட்டுள்ளது.',
  twofa_totp_help: 'இந்த QR குறியீட்டை Google Authenticator, Authy அல்லது 1Password மூலம் ஸ்கேன் செய்யவும். விசையை கையால் உள்ளிடலாம்.',
  twofa_secret_copied: 'விசை நகலெடுக்கப்பட்டது',
  twofa_sms_help: 'சர்வதேச வடிவத்தில் எண்ணை உள்ளிடவும். 6 இலக்க குறியீட்டை SMS மூலம் அனுப்புவோம்.',
  twofa_email_help: 'கணக்கு மின்னஞ்சலுக்கு 6 இலக்க குறியீட்டை அனுப்புவோம்.',
  twofa_backup_title: 'காப்பு குறியீடுகள்',
  twofa_backup_help: 'இந்த ஒருமுறை குறியீடுகளை பாதுகாப்பான இடத்தில் வையுங்கள். தொலைபேசி இழந்தால் ஒவ்வொன்றும் ஒருமுறை பயன்படும்.',
  twofa_copy_codes: 'குறியீடுகளை நகலெடு',
  twofa_codes_copied: 'காப்பு குறியீடுகள் நகலெடுக்கப்பட்டன',
  twofa_regenerate: 'புதிய காப்புக் குறியீடுகளைப் பெறுக',
  twofa_regenerate_hint: 'இது பயன்படுத்தாத காப்புக் குறியீடுகளை மாற்றும். கடவுச்சொல் மற்றும் தற்போதைய குறியீட்டை உள்ளிடுங்கள்.',
  twofa_backup_remaining: '{n} பயன்படுத்தாத காப்புக் குறியீடுகள் மீதம்',
  twofa_new_codes: 'புதிய காப்புக் குறியீடுகள்',
  twofa_sms_unavailable: 'எஸ்எம்எஸ் குறியீடுகள் இன்னும் கிடைக்கவில்லை.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "உங்களுக்கு ஒதுக்கப்பட்ட Kjuup பணிகள் உங்கள் Todoist-இல் உள்ள Kjuup திட்டத்தில் நகலெடுக்கப்படும். Todoist-இல் செய்யும் மாற்றங்கள் திரும்ப நகலெடுக்கப்படாது.",
  todoist_connect: "Todoist இணை",
  todoist_connected: "Todoist இணைக்கப்பட்டது",
  todoist_connect_failed: "Todoist இணைப்பு தோல்வி",
  todoist_disconnect: "துண்டி",
  todoist_disconnected: "Todoist துண்டிக்கப்பட்டது",
  todoist_disconnect_confirm: "Todoist-ஐ துண்டிக்கவா? Todoist-இல் ஏற்கனவே உள்ள பணிகள் இருக்கும். ஒத்திசைவு நிற்கும்.",
  todoist_sync_now: "இப்போது ஒத்திசை",
  todoist_syncing: "ஒத்திசைகிறது…",
  todoist_sync_done: "ஒத்திசைவு முடிந்தது",
  todoist_sync_failed: "ஒத்திசைவு தோல்வி",
  todoist_auth_error: "ஒத்திசைவைத் தொடர Todoist-ஐ மீண்டும் இணைக்கவும்.",
  todoist_last_sync: "கடைசி ஒத்திசைவு",
  todoist_not_connected: "Todoist இணைக்கப்படவில்லை",
  todoist_auth_url_failed: "Todoist அனுமதிப் பக்கத்தைத் திறக்க முடியவில்லை.",
  recommend_text: "Kjuup-இல் சேர், தொடர்பில் இரு, உன் தகவல்தொடர்பை ஒழுங்காக வைத்துக்கொள். உன் எல்லா சேனல்களையும் ஒரே இடத்துக்குக் கொண்டு வா, செய்திகளைச் சரியான திட்டங்களில் வை, ஒவ்வொரு காலையையும் ஒரு சுருக்கத்துடனும் உன் பணிகளுடனும் தொடங்கு – எல்லாம் நீ ஏற்கனவே பயன்படுத்தும் ஆப்களுடன் ஒத்திசைக்கப்படும். இலவசமாகத் தொடங்கு:",
  pro_auth_signin_title: 'மீண்டும் வருக',
  pro_auth_signin_sub: 'உங்கள் பணி மின்னஞ்சலுடன் உள்நுழையவும்.',
  pro_auth_email_or_username: 'மின்னஞ்சல் அல்லது பயனர்பெயர்',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'கடவுச்சொல்லை மறந்துவிட்டீர்களா?',
  pro_auth_create_account: 'கணக்கை உருவாக்கு',
  pro_auth_show_password: 'கடவுச்சொல்லைக் காட்டு',
  pro_auth_hide_password: 'கடவுச்சொல்லை மறை',
  pro_auth_register_sub: 'உங்கள் மின்னஞ்சலை உறுதிப்படுத்த ஒரு இணைப்பை அனுப்புவோம்.',
  pro_auth_register_plus_sub: 'பயனர்பெயர் மற்றும் கடவுச்சொல்லைத் தேர்ந்தெடுக்கவும். அடுத்து உங்கள் பாதுகாப்பு PIN ஐ அமைப்பீர்கள்.',
  pro_auth_check_credentials: 'உங்கள் மின்னஞ்சல் மற்றும் கடவுச்சொல்லைச் சரிபார்க்கவும்',
  pro_news_export_pdf: 'PDF ஆக ஏற்றுமதி செய்',
  pro_news_pdf_failed: 'PDF ஐ உருவாக்க முடியவில்லை.',
  pro_news_pdf_attachments: 'இணைப்புகள்',
  pro_news_pdf_video: 'வீடியோ',
  pro_auth_forgot_sub: 'உங்கள் மின்னஞ்சலை உள்ளிடவும், கடவுச்சொல்லை மீட்டமைக்க ஒரு இணைப்பை அனுப்புவோம்.',
  pro_auth_send_link: 'மீட்டமைப்பு இணைப்பை அனுப்பு',
  pro_auth_plus_reset: 'PIN மூலம் மீட்டமை',
  pro_auth_show_pin: 'PIN ஐக் காட்டு',
  pro_auth_hide_pin: 'PIN ஐ மறை',
  v2_auth_plus_only: 'Kjuup+ மட்டும்',
  room_action_media: "கோப்புகள்",
  room_tab_overview: "கண்ணோட்டம்",
  room_tab_history: "வரலாறு",
  chat_info_media: "கோப்புகள்",
  messages: "செய்திகள்",
  pro_todo_project_required: "ஒரு திட்டத்தைத் தேர்ந்தெடுக்கவும்",
  pro_todo_choose_project: "இந்தப் பணி எந்தத் திட்டத்திற்கானது?",
  cockpit_report_delete_confirm: "இந்த தினசரி அறிக்கையை நீக்கவா?",
  cockpit_report_deleted: "தினசரி அறிக்கை நீக்கப்பட்டது",
  cockpit_tab_company: "நிறுவனம்",
  cockpit_bookmarked_priorities: "புக்மார்க் செய்த பணிகள்",
  cockpit_load_error: "காக்பிட்டை ஏற்ற முடியவில்லை.",
  cockpit_retry: "மீண்டும் முயற்சிக்கவும்",
  cockpit_yesterday: "நேற்று",
  cockpit_greeting_morning: "காலை வணக்கம்",
  cockpit_greeting_day: "மதிய வணக்கம்",
  cockpit_greeting_evening: "மாலை வணக்கம்",
  cockpit_assistant_q_open: "இன்று நிலுவையில் என்ன உள்ளது?",
  cockpit_assistant_q_summarize: "{{room}} அரட்டையைச் சுருக்கவும்",
  cockpit_assistant_q_overdue: "எந்தப் பணிகள் காலக்கெடுவைத் தாண்டியுள்ளன?",
  cockpit_assistant_new: "{{n}} புதியவை",
  cockpit_assistant_important: "{{n}} முக்கியமானவை",
  cockpit_assistant_title: "Kjuup உதவியாளர்",
  cockpit_assistant_hint: "தட்டிக் கேளுங்கள்",
  room_overview_priority_no_detail: "இந்த முன்னுரிமை குறித்து அறிக்கையில் கூடுதல் விவரங்கள் இல்லை.",
  room_overview_priority_from: "மூலம்: {{name}}",
  room_overview_priority_open_task: "பணியைத் திறக்கவும்",
  cockpit_priority_position: "{{total}} இல் {{index}} முன்னுரிமை",
  room_overview_today_title: "இன்று முக்கியம்",
  room_overview_all_tasks: "அனைத்தும்",
  room_overview_tasks_empty: "திறந்த காலக்கெடு அல்லது பணிகள் இல்லை",
  room_overview_appointments_empty: "வரவிருக்கும் சந்திப்புகள் இல்லை",
  room_overview_no_priorities: "சமீபத்திய அறிக்கையில் திறந்த முன்னுரிமைகள் இல்லை.",
  cockpit_report_top5: "முதல் 5 முன்னுரிமைகள்",
  cockpit_report_todo_created: "பணி உருவாக்கப்பட்டது",
  cockpit_report_source_missing: "மூல செய்தி கிடைக்கவில்லை.",
  delete_bookmarked_priority_confirm: "இந்த புக்மார்க் செய்த பணியை நீக்க விரும்புகிறீர்களா?",
  cockpit_report_create_todo: "பணியை உருவாக்கவும்",
  cockpit_priorities_deleting: "நீக்கப்படுகிறது …",
  cockpit_priorities_select: "பலவற்றை நீக்கவும்",
  cockpit_report_none: "உள்ளீடுகள் இல்லை.",
  cockpit_priorities_delete_confirm: "{count} புக்மார்க் செய்த பணிகளை நீக்க விரும்புகிறீர்களா?",
  cockpit_priorities_delete_failed: "{count} பணிகளை நீக்க முடியவில்லை",
  cockpit_priorities_deleted: "{count} பணிகள் நீக்கப்பட்டன",
  cockpit_priorities_selected: "{count} தேர்ந்தெடுக்கப்பட்டது",
  cockpit_channel_connected: "இணைக்கப்பட்டது",
  cockpit_channel_not_connected: "இணைக்கப்படவில்லை",
  cockpit_channel_connect: "இணைக்கவும்",
  cockpit_channel_chat: "Kjuup அரட்டை",
  cockpit_channel_active: "செயலில்",
  cockpit_channel_hidden: "மறைக்கப்பட்டது",
  cockpit_channel_enable: "இயக்கவும்",
  cockpit_channel_email: "மின்னஞ்சல்",
  cockpit_channel_check: "இணைப்பைச் சரிபார்க்கவும்",
  cockpit_channel_fix: "சரிபார்க்கவும்",
  cockpit_channel_forward: "முன்னனுப்பும் முகவரி",
  cockpit_channel_not_set_up: "அமைக்கப்படவில்லை",
  cockpit_channel_set_up: "அமைக்கவும்",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "இணைப்பு துண்டிக்கப்பட்டது",
  cockpit_channel_importing: "இறக்குமதி செய்யப்படுகிறது",
  cockpit_channel_removing: "இணைப்பு துண்டிக்கப்படுகிறது",
  cockpit_channel_reconnect: "மீண்டும் இணைக்கவும்",
  cockpit_channels_title: "சேனல்கள்",
  cockpit_company_role_super_admin: "நிறுவன நிர்வாகி",
  cockpit_company_role_dept_admin: "துறை நிர்வாகி",
  cockpit_company_role_member: "ஊழியர்",
  cockpit_company_none: "Kjuup+ நிறுவனம் எதுவும் கிடைக்கவில்லை",
  cockpit_company_eyebrow: "நிறுவனம்",
  cockpit_company_inactive: "செயலற்றது",
  cockpit_company_settings: "நிறுவன அமைப்புகள்",
  cockpit_company_employees: "ஊழியர்கள்",
  cockpit_company_internal_rooms: "உள் திட்டங்கள்",
  cockpit_report_all_projects: "அனைத்து திட்டங்கள்",
  cockpit_report_progress_emails: "மின்னஞ்சல்கள் பகுப்பாய்வு செய்யப்படுகின்றன",
  cockpit_report_progress_chats: "அரட்டை செய்திகள் பகுப்பாய்வு செய்யப்படுகின்றன",
  cockpit_report_progress_documents: "இணைப்புகள் மற்றும் ஆவணங்கள் பகுப்பாய்வு செய்யப்படுகின்றன",
  cockpit_report_progress_tasks: "பணிகள் பகுப்பாய்வு செய்யப்படுகின்றன",
  cockpit_report_progress_summarizing: "உள்ளடக்கம் பகுப்பாய்வு செய்யப்படுகிறது",
  cockpit_report_progress_reading: "ஏற்கனவே பகுப்பாய்வு செய்த உள்ளடக்கம் மீண்டும் பயன்படுத்தப்படுகிறது",
  cockpit_report_progress_collecting: "உங்கள் திட்டங்களிலிருந்து மின்னஞ்சல்கள், அரட்டைகள் மற்றும் பணிகள் சேகரிக்கப்படுகின்றன",
  cockpit_report_progress_priorities: "முன்னுரிமைகள், காலக்கெடுக்கள் மற்றும் முடிவுகள் தொகுக்கப்படுகின்றன",
  cockpit_report_progress_queued: "அறிக்கை தயாராகிறது",
  cockpit_report_creating_title: "உங்கள் தினசரி அறிக்கை தயாராகிறது",
  cockpit_report_progress_count_one: "1 உருப்படி பகுப்பாய்வு செய்யப்பட்டது",
  cockpit_report_progress_count_many: "{{count}} உருப்படிகள் பகுப்பாய்வு செய்யப்பட்டன",
  cockpit_report_progress_hint: "இதற்கு பொதுவாக ஒன்று முதல் இரண்டு நிமிடங்கள் ஆகும் – அதுவரை நீங்கள் காக்பிட்டைத் தொடர்ந்து பயன்படுத்தலாம்.",
  cockpit_report_time_hint: "மிகவும் செயல்பாடுள்ள ஐந்து திட்டங்களுக்கான தினசரி அறிக்கை ஒவ்வொரு நாளும் {{hour}}:00 மணிக்கு உருவாக்கப்படும்.",
  room_overview_priorities_title: "தற்போதைய நிலை மற்றும் முன்னுரிமைகள்",
  room_overview_as_of: "{{time}} நிலவரப்படி",
  cockpit_report_delete: "தினசரி அறிக்கையை நீக்கவும்",
  email_tag_daily_briefing: "தினசரி அறிக்கை",
  cockpit_report_unread: "புதியது",
  cockpit_report_clear_project: "அனைத்து திட்டங்களையும் காட்டு",
  cockpit_filter_project: "திட்டம்",
  cockpit_filter_all_projects: "அனைத்து திட்டங்கள்",
  cockpit_report_recreate: "தினசரி அறிக்கையை மீண்டும் உருவாக்கவும்",
  cockpit_report_hide_previous: "முந்தைய தினசரி அறிக்கைகளை மறை",
  cockpit_report_show_previous: "முந்தைய தினசரி அறிக்கைகளைக் காட்டு",
  cockpit_report_room_empty: "இந்தத் திட்டத்திற்கு இன்னும் தினசரி அறிக்கை இல்லை",
  cockpit_report_empty: "இன்னும் தினசரி அறிக்கை இல்லை",
  cockpit_report_room_empty_hint: "இந்தத் திட்டத்திற்கு மட்டும் தினசரி அறிக்கையை உருவாக்கவும்.",
  cockpit_report_needs_mailbox: "தானியங்கி பணிகளுடன் Kjuup தினசரி அறிக்கையை உருவாக்க மின்னஞ்சல் கணக்கை இணைக்கவும்.",
  cockpit_report_create: "தினசரி அறிக்கையை உருவாக்கவும்",
  cockpit_email_connect: "மின்னஞ்சலை இணைக்கவும்",
  cockpit_email_none_title: "இன்னும் மின்னஞ்சல் கணக்கு இணைக்கப்படவில்லை",
  cockpit_email_none_reports: "Kjuup வரும் மின்னஞ்சல்களை உங்கள் திட்டங்களுக்கு ஒதுக்கி, பணிகளுடன் தினசரி அறிக்கைகளை உருவாக்க உங்கள் மின்னஞ்சல் பெட்டியை இணைக்கவும்.",
  cockpit_email_none_client: "Kjuup.io-விலேயே மின்னஞ்சல்களைப் படிக்க, ஒதுக்க மற்றும் பதிலளிக்க Gmail, Outlook அல்லது IMAP-ஐ இணைக்கவும்.",
  cockpit_email_reports_title: "தற்போதைய மின்னஞ்சல் கிளையன்ட்",
  cockpit_email_reports_text: "Kjuup.io-வில் இன்பாக்ஸ் இல்லை · தினமும் {{hour}}:00 மணிக்கு தினசரி அறிக்கையுடன் {{rooms}} திட்டங்கள் · வரும் மின்னஞ்சல்கள் உங்கள் திட்டங்களுக்கு ஒதுக்கப்படும்.",
  cockpit_email_reports_rooms: "திட்டங்களை நிர்வகிக்கவும்",
  cockpit_email_settings: "மின்னஞ்சல் அமைப்புகள்",
  cockpit_email_error_title: "இணைப்பைச் சரிபார்க்கவும்",
  cockpit_email_client_title: "இன்பாக்ஸ் இணைக்கப்பட்டது",
  cockpit_email_accounts_n: "{{n}} கணக்கு இணைக்கப்பட்டது",
  cockpit_email_last_sync: "கடைசி ஒத்திசைவு {{when}}",
  cockpit_email_report_at: "{{hour}}:00 மணிக்கு தினசரி அறிக்கை",
  cockpit_email_open_inbox: "இன்பாக்ஸைத் திறக்கவும்",
  cockpit_email_eyebrow: "Kjuup-மின்னஞ்சல்",
  cockpit_email_accounts_label: "இணைக்கப்பட்ட மின்னஞ்சல் முகவரிகள்",
  email_folder_sent: "அனுப்பிய உருப்படிகள்",
  email_no_subject: "(தலைப்பு இல்லை)",
  cockpit_email_detail_loading: "மின்னஞ்சல் ஏற்றப்படுகிறது …",
  cockpit_email_detail_failed: "மின்னஞ்சலை ஏற்ற முடியவில்லை.",
  cockpit_email_detail_empty: "இந்த மின்னஞ்சலில் உரை இல்லை.",
  cockpit_personal_settings: "தனிப்பட்ட அமைப்புகள்",
  cockpit_companies: "நிறுவனங்கள்",
  cockpit_title: "காக்பிட்",
  cockpit_back: "மேலோட்டத்திற்குத் திரும்பு",
  cockpit_day_overview: "ஒரே பார்வையில் உங்கள் நாள்",
  email_saved_to_project: "மின்னஞ்சல் திட்டத்தில் சேமிக்கப்பட்டது",
  email_classify_need_project: "தயவுசெய்து திட்டத்தின் பெயரை உள்ளிடவும்",
  cockpit_email_deleted: "மின்னஞ்சல் நீக்கப்பட்டது",
  cockpit_email_sent_empty: "இன்னும் அனுப்பிய மின்னஞ்சல்கள் இல்லை.",
  cockpit_email_incoming_empty: "இன்னும் வந்த மின்னஞ்சல்கள் இல்லை.",
  cockpit_email_incoming_title: "மின்னஞ்சல்கள்",
  cockpit_email_incoming_sub: "வந்த மற்றும் அனுப்பிய மின்னஞ்சல்களை உங்கள் திட்டங்களுக்கு ஒதுக்கவும். ஒதுக்கீட்டை இங்கே மாற்றலாம்.",
  cockpit_email_incoming_unassigned_n: "{{n}} ஒதுக்கப்படவில்லை",
  cockpit_email_folder_inbox: "இன்பாக்ஸ்",
  cockpit_email_folder_sent: "அனுப்பியவை",
  cockpit_email_open: "மின்னஞ்சலைத் திறக்கவும்",
  cockpit_email_incoming_suggested: "பரிந்துரை: {{room}}",
  cockpit_email_incoming_apply: "பயன்படுத்து",
  cockpit_email_incoming_adjust: "ஒதுக்கீட்டை மாற்றவும்",
  cockpit_email_incoming_saving: "சேமிக்கப்படுகிறது …",
  cockpit_email_incoming_unassigned: "ஒதுக்கப்படவில்லை",
  cockpit_email_incoming_show_less: "குறைவாகக் காட்டு",
  cockpit_email_incoming_show_all: "அனைத்து {{n}}-ஐயும் காட்டு",
  cockpit_io_settings: "Kjuup.io அமைப்புகள்",
  cockpit_io_settings_sub: "திட்டம் மற்றும் இருக்கைகள், ஊழியர் ஒதுக்கீடு, பில்லிங் மற்றும் விலைப்பட்டியல்கள்.",
  products_coming_soon: "விரைவில் வருகிறது",
  cockpit_upsell_io_title: "உங்களுடன் சேர்ந்து சிந்திக்கும் உங்கள் அலுவலகம்",
  cockpit_upsell_io_text: "உங்கள் மின்னஞ்சல் கணக்குகளை Kjuup உடன் இணைக்கவும். மின்னஞ்சல்கள், இணைப்புகள் மற்றும் செய்திகள் பொருத்தமான திட்டத்தில் தானாகவே சேமிக்கப்படும், விரும்பினால் உங்கள் சர்வரிலும் சேமிக்கலாம். ஒவ்வொரு நாளும் அனைத்து திட்டங்களின் சுருக்கமும் அனைத்து உள்ளடக்கத்தின் முக்கிய அம்சங்களும் கிடைக்கும், உங்கள் பணிகள் உங்கள் நாள்காட்டி அல்லது to-do செயலியுடன் ஒத்திசைக்கப்படும்.",
  cockpit_upsell_io_soon_title: "இன்னும் முன்பதிவு செய்ய இயலாது",
  cockpit_upsell_io_soon_text: "Kjuup.io விரைவில் தொடங்கவுள்ளது. இப்போதே தகவலைக் கோருங்கள் – Kjuup.io-ஐ முன்பதிவு செய்ய முடிந்தவுடன் உங்களுக்குத் தெரிவிப்போம்.",
  cockpit_upsell_io_planned_price: "திட்டமிட்ட விலை",
  cockpit_upsell_io_cta_request: "தகவல் கோருங்கள்",
  kjuup_plus_abo_per_year: "/ ஆண்டு",
  kjuup_plus_abo_per_month: "/ மாதம்",
  kjuup_plus_abo_status_active: "செயலில்",
  kjuup_plus_abo_status_requested: "ரத்து கோரப்பட்டது",
  kjuup_plus_abo_status_past_due: "பணம் செலுத்த வேண்டியுள்ளது",
  kjuup_plus_abo_eyebrow: "Kjuup+ · சந்தா",
  kjuup_plus_abo_title: "Kjuup+ தொகுப்பு",
  kjuup_plus_abo_seats_free_one: "1 இருக்கை மீதமுள்ளது",
  kjuup_plus_abo_billing: "பில்லிங்",
  kjuup_plus_abo_yearly: "ஆண்டுதோறும்",
  kjuup_plus_abo_monthly: "மாதந்தோறும்",
  kjuup_plus_abo_amount: "தொகை",
  kjuup_plus_abo_ends: "முடிவடையும் தேதி",
  kjuup_plus_abo_renews: "அடுத்த புதுப்பித்தல்",
  kjuup_plus_abo_next_invoice: "அடுத்த விலைப்பட்டியல்",
  kjuup_plus_abo_intro: "அறிமுக விலை",
  kjuup_plus_abo_pending_tier: "அடுத்த புதுப்பித்தல் முதல்",
  kjuup_plus_abo_manual: "Kjuup+ உங்கள் நிறுவனத்திற்கு தனிப்பட்ட ஒப்பந்தத்தின்படி செயலில் உள்ளது.",
  kjuup_plus_abo_invoices: "விலைப்பட்டியல்கள்",
  kjuup_plus_abo_invoice_paid: "செலுத்தப்பட்டது",
  kjuup_plus_abo_invoice_view: "பார்க்கவும்",
  kjuup_plus_abo_invoices_less: "குறைவாகக் காட்டு",
  kjuup_plus_abo_member_hint: "பில்லிங் மற்றும் ரத்து செய்தலை உங்கள் நிறுவன நிர்வாகிகள் நிர்வகிக்கிறார்கள்.",
  kjuup_plus_abo_withdraw: "கோரிக்கையைத் திரும்பப் பெறவும்",
  kjuup_plus_abo_cancel_note: "காரணம் (விருப்பத்தேர்வு)",
  kjuup_plus_abo_cancel_send: "ரத்து செய்யக் கோரவும்",
  kjuup_plus_abo_cancel: "சந்தாவை ரத்து செய்யவும்",
  cockpit_upsell_plus_f1: "உங்கள் அனைத்து ஊழியர்களின் தகவல்தொடர்பு செயல்பாடுகளை நிர்வகிக்கவும்",
  cockpit_upsell_plus_f2: "நிறுவனத்திற்குள் குறிப்பிட்ட பயனர் குழுக்களுக்குத் தெரிவிக்கவும்",
  cockpit_upsell_plus_f3: "உள் குழு அரட்டைகளைச் சேமிக்கவும்",
  cockpit_upsell_plus_when_yearly: "ஆண்டுக்கு ஒருமுறை செலுத்தினால்",
  cockpit_upsell_plus_size_small: "1–50 ஊழியர்கள்",
  cockpit_upsell_plus_size_large: "51–200 ஊழியர்கள்",
  cockpit_upsell_plus_title: "நிறுவனங்களுக்கான Kjuup+",
  cockpit_upsell_plus_text: "ஊழியர்கள், எழுதும் அனுமதிகள் மற்றும் நிறுவன தகவல்தொடர்பை ஒரே இடத்தில் நிர்வகிக்கவும். உள் சேனல்கள் உங்கள் குழுவிலேயே இருக்கும், வெளி சேனல்கள் உங்களை திட்டப் பங்காளர்களுடன் இணைக்கும், குறிப்பிட்ட குழுக்களை நேரடியாக அணுகலாம். Kjuup+ உடன் கூடுதலாக, ஊழியர் குழுக்களுக்கு Kjuup.io அணுகலையும் முன்பதிவு செய்யலாம். Kjuup+ மற்றும் Kjuup.io-ஐ இணைத்துப் பயன்படுத்தலாம்.",
  cockpit_upsell_plus_size: "நிறுவனத்தின் அளவு",
  cockpit_upsell_plus_billing: "பில்லிங்",
  cockpit_upsell_plus_per_company: "/ நிறுவனம் · மாதம், VAT தவிர",
  cockpit_upsell_plus_onboarding: "அறிமுகம்/ஆன்போர்டிங் செலவுகள் நிறுவனத்தின் அளவைப் பொறுத்தது",
  cockpit_upsell_plus_larger: "பெரிய நிறுவனங்களுக்கான விலை கோரிக்கையின் பேரில்",
  cockpit_upsell_plus_cta: "கடப்பாடு இல்லாமல் விசாரிக்கவும்",
  cockpit_kpi_deadlines_tasks: "காலக்கெடுக்கள் & பணிகள்",
  cockpit_kpi_appointments: "சந்திப்புகள்",
  cockpit_room_admin: "திட்டம் & அரட்டை நிர்வாகம்",
  cockpit_room_admin_sub: "உறுப்பினர்கள், மீடியா மற்றும் அரட்டைகளுடன் நிறுவனத்தின் அனைத்து திட்டங்கள்.",
  pro_todo_not_found: "இந்தப் பணி இனி கிடைக்காது.",
  cockpit_chip_overdue: "காலக்கெடு தாண்டியது",
  cockpit_chip_today: "இன்று",
  cockpit_calendar_week: "வாரம் {{week}}",
  cockpit_prev_week: "முந்தைய வாரம்",
  cockpit_next_week: "அடுத்த வாரம்",
  cockpit_chip_requested: "கோரப்பட்டது",
  cockpit_todo_due: "காலக்கெடு {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} இடமிருந்து",
  cockpit_todo_since: "{{when}} முதல்",
  cockpit_todo_no_date: "தேதி இல்லை",
  cockpit_todo_mark_done: "முடிந்தது எனக் குறிக்கவும்",
  cockpit_my_tasks_title: "எனது பணிகள்",
  cockpit_today_tasks_group: "இன்றைய பணிகள்",
  cockpit_assign_none: "யாருக்கும் ஒதுக்கப்படவில்லை",
  no_project_found: "திட்டம் எதுவும் கிடைக்கவில்லை",
  cockpit_row_more_actions: "மேலும் செயல்கள்",
  needs_date: "தேதியை ஒதுக்கவும்",
  cockpit_assign_proposal: "{{name}} அடையாளம் காணப்பட்டது – ஒதுக்கவா?",
  cockpit_assign_proposal_confirm: "ஒதுக்கவும்",
  cockpit_assign_proposal_dismiss: "புறக்கணிக்கவும்",
  cockpit_priority_date: "தேதி",
  todo_calendar_add: "நாள்காட்டியில் சேர்க்கவும்",
  todo_calendar_remove: "நாள்காட்டியிலிருந்து நீக்கவும்",
  cockpit_todo_change_project: "திட்டத்தை மாற்றவும்",
  cockpit_todo_set_date: "தேதியை அமைக்கவும்",
  pro_todo_done_confirm: "இந்தப் பணியை உண்மையில் முடிந்தது எனக் குறிக்க விரும்புகிறீர்களா?",
  cockpit_task_delete_failed: "பணியை நீக்க முடியவில்லை.",
  cockpit_setup_title: "அமைப்பை முடிக்கவும்",
  cockpit_setup_text: "நீங்கள் அரட்டைகளைப் பயன்படுத்த விரும்புகிறீர்களா, மேலும் Kjuup.io மின்னஞ்சல் கிளையன்ட்டாகச் செயல்பட வேண்டுமா அல்லது திட்டங்கள் மற்றும் தினசரி அறிக்கைகளுடன் மட்டும் செயல்பட வேண்டுமா என்பதைத் தீர்மானிக்கவும்.",
  cockpit_setup_cta: "இப்போதே அமைக்கவும்",
  cockpit_group_tasks: "காலக்கெடுக்கள் & பணிகள்",
  cockpit_group_appointments: "சந்திப்புகள்",
  cockpit_report_no_activity: "கடந்த 24 மணி நேரத்தில் இந்தத் திட்டத்தில் புதிய செய்திகள் அல்லது மின்னஞ்சல்கள் இல்லை.",
  cockpit_report_room_unavailable: "இந்தத் திட்டம் கிடைக்கவில்லை.",
  cockpit_report_create_failed: "தினசரி அறிக்கையை உருவாக்க முடியவில்லை.",
  cockpit_report_created: "தினசரி அறிக்கை உருவாக்கப்பட்டது",
  addon_enable_confirm: "add-on-ஐ இயக்கவா?",
  addon_enable: "இயக்கவும்",
  addon_enabled: "add-on இயக்கப்பட்டது",
  nav_email: "மின்னஞ்சல்",
  nav_my_cockpit: "எனது காக்பிட்",
  nav_news: "செய்திகள்",
  nav_recommend: "பரிந்துரைக்கவும்",
  pro_todo_status_done: "முடிந்தது",
  pro_todo_status_open: "திறந்தது",
  v2_todo_remove: "அகற்று",
  pro_todo_search_people: "நபர்களைத் தேடவும்",
  pro_todo_clear: "அழி",
  pro_todo_assigned: "(ஒதுக்கப்பட்டது)",
  pro_todo_no_people: "நபர்கள் யாரும் கிடைக்கவில்லை",
  pro_todo_search_rooms: "திட்டங்களைத் தேடவும்",
  pro_todo_no_rooms_match: "“{{q}}” உடன் பொருந்தும் திட்டங்கள் இல்லை",
  pro_todo_no_rooms: "திட்டங்கள் எதுவும் கிடைக்கவில்லை",
  pro_todo_activity: "செயல்பாடு",
  pro_todo_show_less: "குறைவாகக் காட்டு",
  pro_todo_show_all: "அனைத்தையும் காட்டு ({{n}})",
  pro_todo_due: "காலக்கெடு",
  pro_todo_room: "திட்டம்",
  pro_todo_select_room: "திட்டத்தைத் தேர்ந்தெடுக்கவும்",
  pro_todo_status: "நிலை",
  pro_todo_more: "மேலும்",
  pro_todo_edit_title: "பணியைத் திருத்தவும்",
  pro_todo_description: "விளக்கம்",
  pro_todo_created_by: "உருவாக்கியவர்",
  pro_todo_chat: "அரட்டை",
  navigate_to_source: "மூலத்திற்குச் செல்லவும்",
  todo_calendar_connect_title: "நாள்காட்டி எதுவும் இணைக்கப்படவில்லை",
  todo_calendar_connect_body_web: "ToDo-க்களைச் சேர்க்க நாள்காட்டி ஒத்திசைவு அமைப்புகளில் நாள்காட்டியை இணைக்கவும்.",
  todo_calendar_connect: "இணைக்கவும்",
  todo_calendar_removed: "உங்கள் நாள்காட்டியிலிருந்து நீக்கப்பட்டது",
  todo_calendar_added_later: "சேர்க்கப்பட்டது. உங்கள் நாள்காட்டியை அடைய முடியவில்லை; Kjuup பின்னர் மீண்டும் முயற்சிக்கும்.",
  todo_calendar_added: "உங்கள் நாள்காட்டியில் சேர்க்கப்பட்டது",
  todo_calendar_no_date: "தேதி உள்ள ToDo-வை மட்டுமே நாள்காட்டியில் சேர்க்க முடியும்.",
  todo_calendar_failed: "உங்கள் நாள்காட்டியைப் புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  todo_calendar_date_title: "இன்னும் தேதி இல்லை",
  todo_calendar_date_save: "தேதியை அமைத்துச் சேர்க்கவும்",
  todo_calendar_date_body_web: "இந்த புக்மார்க் செய்த பணிக்கு இன்னும் தேதி இல்லை. நாள்காட்டியில் சேர்க்க ஒரு தேதியை அமைக்கவும்.",
  kjuup_io_setup_saved: "அமைப்பு சேமிக்கப்பட்டது",
  kjuup_io_setup_step: "படி",
  kjuup_io_setup_chats_title: "நீங்கள் அரட்டைகளைப் பயன்படுத்த விரும்புகிறீர்களா?",
  kjuup_io_setup_email_title: "உங்கள் மின்னஞ்சல்களை எங்கே படிக்க விரும்புகிறீர்கள்?",
  kjuup_io_setup_chats_sub: "சக ஊழியர்கள் மற்றும் திட்டப் பங்காளர்களுடனான அரட்டைகள் விருப்பத்தேர்வு. அவற்றை எப்போது வேண்டுமானாலும் காக்பிட்டில் காட்டலாம் அல்லது மறைக்கலாம்.",
  kjuup_io_setup_email_sub: "நீங்கள் Kjuup-இல் மின்னஞ்சல் கிளையன்ட்டைப் பயன்படுத்துவீர்களா அல்லது Outlook போன்ற உங்கள் தற்போதைய மின்னஞ்சல் நிரலையே தொடர்வீர்களா என்பதை மட்டுமே இது தீர்மானிக்கிறது. பின்னர் மாற்றலாம்.",
  kjuup_io_setup_chats_yes: "ஆம், அரட்டைகளைக் காட்டு",
  kjuup_io_setup_chats_yes_text: "செய்திகளில் அரட்டைகள் மற்றும் மின்னஞ்சல்கள் உள்ளன. திட்டங்களில் ஈடுபட்ட அனைவருக்கும் குழு அரட்டைகள் உள்ளன.",
  kjuup_io_setup_chats_no: "இல்லை, அரட்டைகள் இல்லாமல் வேலை செய்",
  kjuup_io_setup_chats_no_text: "அரட்டைகள் மறைக்கப்படும். \"செய்திகள்\" என்பது \"மின்னஞ்சல்\" ஆகும்; திட்டங்கள், பணிகள் மற்றும் தினசரி அறிக்கைகள் அப்படியே இருக்கும்.",
  kjuup_io_setup_email_client: "Kjuup-இல் மின்னஞ்சல் கிளையன்ட்",
  kjuup_io_setup_email_client_text: "மின்னஞ்சல்களை நேரடியாக Kjuup-இல் படித்துப் பதிலளிக்கவும்.",
  kjuup_io_setup_email_reports: "தற்போதைய மின்னஞ்சல் கிளையன்ட்",
  kjuup_io_setup_email_reports_text: "Outlook அல்லது வேறொன்று போன்ற உங்கள் தற்போதைய நிரலிலேயே படித்துப் பதிலளிப்பதைத் தொடரவும்.",
  kjuup_io_setup_skip: "பின்னர்",
  next: "அடுத்து",
  kjuup_io_setup_finish: "அமைப்பை முடிக்கவும்",
  today_label: "இன்று",
  tomorrow_label: "நாளை",
  cockpit_todo_overdue: "காலக்கெடு தாண்டியது",
  cockpit_report_management_fazit: "மேலாண்மைச் சுருக்கம்",
  cockpit_todo_appointment: "சந்திப்பு",
  cockpit_todo_deadline: "காலக்கெடு",
  cockpit_todo_deadline_define: "காலக்கெடுவை வரையறுக்கவும்",
  pro_todo_status_acknowledged: "உறுதிப்படுத்தப்பட்டது",
  pro_todo_responsible: "பொறுப்பாளர்",
  pro_todo_notice_confirmed: "அரட்டையில் உறுதிப்படுத்தப்பட்டது",
  pro_todo_notice_sent_at: "செய்தி அனுப்பப்பட்டது",
  pro_todo_notice_again: "செய்தியை மீண்டும் அனுப்பவும்",
  pro_todo_notice_send: "Kjuup செய்தி மூலம் தெரிவிக்கவும்",
  pro_todo_add_assignee: "சேர்க்கவும்",
  pro_todo_edit: "திருத்தவும்",
  pro_todo_change_room: "திட்டத்தை மாற்றவும்",
  pro_todo_due_on: "காலக்கெடு தேதி",
  pro_todo_edit_due: "காலக்கெடுவைத் திருத்தவும்",
  pro_todo_no_date: "தேதி இல்லை",
  pro_todo_edit_description: "விளக்கத்தைத் திருத்தவும்",
  pro_todo_no_description: "இன்னும் விளக்கம் இல்லை",
  pro_todo_title_label: "தலைப்பு",
  pro_todo_title_placeholder: "தலைப்பை உள்ளிடவும்...",
  pro_todo_task: "பணி",
  pro_todo_what: "என்ன செய்ய வேண்டும்?",
  pro_todo_source_email: "மின்னஞ்சல்",
  pro_todo_sources: "ஆதாரங்கள்",
  previous: "முந்தையது",
  kjuup_plus_abo_tier_large: "Kjuup+ Large ({max} ஊழியர்கள் வரை)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small ({max} ஊழியர்கள் வரை)",
  kjuup_plus_abo_status_ends: "{date} அன்று முடிகிறது",
  kjuup_plus_abo_seats_over: "{max}-க்கும் மேற்பட்ட ஊழியர்கள் – Kjuup தனிப்பயன் சலுகையுடன் உங்களைத் தொடர்புகொள்ளும்.",
  kjuup_plus_abo_seats_next: "மேலும் ஊழியர்கள் சேர்ந்தால், தொகுப்பு தானாகவே {next}-க்கு மாறும் (விகிதாசாரக் கட்டணம்).",
  kjuup_plus_abo_seats_used: "{total} இருக்கைகளில் {used} பயன்படுத்தப்பட்டுள்ளன",
  kjuup_plus_abo_seats_free: "{count} இருக்கைகள் மீதமுள்ளன",
  kjuup_plus_abo_intro_until: "{date} வரை",
  kjuup_plus_abo_invoice_open: "நிலுவையில் · செலுத்த வேண்டியது {date}",
  kjuup_plus_abo_invoices_all: "அனைத்து {count}-ஐயும் காட்டு",
  kjuup_plus_abo_requested_hint: "{date} அன்று ரத்து கோரப்பட்டது. காலத்தின் முடிவில் ({end}) Kjuup இதை உறுதிப்படுத்தும்.",
  kjuup_plus_abo_cancel_hint: "Kjuup உங்கள் கோரிக்கையைப் பரிசீலித்து, காலத்தின் முடிவில் ({end}) ரத்தை உறுதிப்படுத்தும். அதுவரை Kjuup+ செயலில் இருக்கும்.",
  kjuup_plus_abo_withdrawn: "ரத்து கோரிக்கை திரும்பப் பெறப்பட்டது",
  kjuup_plus_abo_requested: "ரத்து கோரப்பட்டது",
  cockpit_upsell_plus_intro_hint: "முதல் {months} மாதங்கள், பின்னர் {price}",
  cockpit_upsell_plus_badge: "{months} மாதங்களுக்கு அறிமுக விலை",
  calendar_syncing: "நாட்காட்டியிலிருந்து புதுப்பிக்கிறது…",
  calendar_sync_up_to_date: "நாட்காட்டி புதுப்பித்த நிலையில் உள்ளது",
  calendar_sync_failed: "ஒத்திசைவு தோல்வியடைந்தது",
  delete_multiple_tasks_confirm: "{count} ToDoகளை நீக்க விரும்புகிறீர்களா?",
  todos_deleted_count: "{count} ToDoகள் நீக்கப்பட்டன",
  todos_deleted_partial: "{ok} ToDoகள் நீக்கப்பட்டன, {fail} தோல்வியடைந்தன",
  todo_unknown: "தெரியாத",
  todo_created_from_message: "இந்தச் செய்தியிலிருந்து பணி உருவாக்கப்பட்டது",
  kjuup_io_todo_calendar_trial_ended_note: "காலண்டர் ஒத்திசைவு · சந்தா பெறு",
  kjuup_io_todo_calendar_nudge: "இந்த ToDo ஐ உங்கள் காலண்டருடன் ஒத்திசைக்கவா?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io ஐ செயல்படுத்து",
  todo_confirmed: "ToDo உறுதிப்படுத்தப்பட்டது",
  pro_todo_bulk_delete_title: "{{n}} பணிகளை நீக்கவா?",
  pro_todo_previous_none_own: "காலாவதியான பணிகள் பிறரால் உங்களுக்கு ஒதுக்கப்பட்டவை, அவர்களால் மட்டுமே நீக்க முடியும்.",
  pro_todo_previous_none: "காலாவதியான பணிகள் இல்லை",
  pro_todo_previous_title: "காலாவதியான {{n}} பணிகளை நீக்கவா?",
  pro_todo_previous_text: "முந்தைய நாட்களின் உங்கள் திறந்த பணிகள் அனைத்தும் நீக்கப்படும்.",
  pro_todo_previous_skipped: "பிறரால் ஒதுக்கப்பட்ட {{n}} பணிகள் அப்படியே இருக்கும்.",
  unassign_task_confirm: "இந்த பணியிலிருந்து உங்கள் ஒதுக்கீட்டை ரத்து செய்ய விரும்புகிறீர்களா?",
  unassign_label: "ரத்து செய்",
  pro_todo_delete_title: "பணியை நீக்கு",
  pro_todo_today: "இன்று",
  pro_todo_yesterday: "நேற்று",
  pro_todo_since_yesterday: "நேற்றிலிருந்து",
  pro_todo_mark_open: "திறந்ததாகக் குறி",
  verify_completion: "சரிபார்க்கவும்",
  new_label: "புதியது",
  bookmarked_no_mylist: "புக்மார்க் செய்த பணிகளை எனது பட்டியலில் சேர்க்க முடியாது",
  delete_only_own: "நீங்கள் உருவாக்கிய பணிகளை மட்டுமே நீக்க முடியும்",
  todo_clear_all: "அனைத்தையும் அழி",
  pro_todo_of_completed: "{{total}}-இல் {{done}} முடிந்தது",
  pro_todo_pick_date: "ஒரு தேதியைத் தேர்ந்தெடு",
  pro_todo_show_day: "நாளைக் காட்டு",
  todo_adjust_list: "பட்டியலை சரிசெய்",
  pro_todo_section_upcoming: "வரவிருப்பவை",
  pro_todo_section_done: "முடிந்தது",
  pro_todo_room_empty_today: "இந்தத் திட்டத்தில் இன்று பணிகள் இல்லை",
  pro_todo_room_empty_day: "இந்தத் திட்டத்தில் இந்த நாளில் பணிகள் இல்லை",
  pro_todo_delete_previous: "அனைத்தையும் நீக்கு",
  todo_my_list_empty: "உங்கள் நாள் காலியாக உள்ளது",
  todo_my_list_empty_hint: "பணிகளைச் சேர்க்க “பட்டியலைச் சரிசெய்” என்பதைக் கிளிக் செய்யவும்",
  pro_todo_empty_title: "இங்கே எதுவும் இல்லை",
  pro_todo_empty_hint: "இந்தக் காட்சியுடன் பொருந்தும் பணிகள் இல்லை.",
  pro_todo_selected: "{{n}} தேர்ந்தெடுக்கப்பட்டன",
  delete_selected_count: "நீக்கு ({count})",
  pro_todo_adjust_done: "முடிந்தது",
  pro_todo_deleting: "நீக்கப்படுகிறது...",
  pro_todo_reopen: "பணியை மீண்டும் திற",
  pro_todo_step_done: "முடிந்தது",
  move_back_in_progress: "மீண்டும் நடந்துகொண்டிருப்பதற்கு நகர்த்து",
  pro_todo_mark_not_started: "தொடங்கப்படவில்லை எனக் குறி",
  back_into_in_progress: "மீண்டும் செயல்பாட்டில்",
  pro_todo_mark_in_progress: "நடைபெறுவதாகக் குறி",
  unassign_todo: "ToDo ஒதுக்கீட்டை ரத்து செய்",
  pro_todo_open_room: "திட்டத்தைத் திற",
  pro_todo_new_task: "புதிய பணி",
  select_user_back_to_in_progress: "மீண்டும் நடந்துகொண்டிருப்பதற்கு நகர்த்த பயனரைத் தேர்ந்தெடுக்கவும்",
  cockpit_email_accounts_n_many: "{{n}} கணக்குகள் இணைக்கப்பட்டன",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup தொடர்புகள்",
  combined_tab_teams: "Teams தொடர்புகள்",
  combined_bridge_failed: "Teams நகலை உருவாக்க முடியவில்லை.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup மற்றும் Teams தொடர்புகள்: Microsoft Teams-லும் தோன்றும் புதிய குழு உருவாக்கப்படும்.",
  teams_new_chat_title: "புதிய Teams அரட்டை",
  teams_new_chat_topic: "குழுவின் பெயர் (விருப்பத்தேர்வு)",
  teams_new_chat_start: "அரட்டையைத் தொடங்கு",
  teams_new_chat_creating: "அரட்டை உருவாக்கப்படுகிறது…",
  teams_new_chat_forbidden: "Microsoft Teams இந்த அரட்டையை அனுமதிக்கவில்லை (எ.கா. உங்கள் நிறுவனத்திற்கு வெளியே உள்ள நபர் அல்லது உங்கள் IT கொள்கை).",
  teams_new_chat_too_many: "ஒரு அரட்டைக்கு அதிகமான நபர்கள்.",
  teams_new_chat_type_hint: "உங்கள் நிறுவனத்தில் தேட ஒரு பெயரைத் தட்டச்சு செய்யவும்.",
  teams_new_chat_directory_forbidden: "உங்கள் நிறுவனம் கோப்பகத் தேடலை அனுமதிக்கவில்லை. உங்கள் Teams அரட்டைகளில் உள்ள நபர்கள் மட்டுமே காட்டப்படுகின்றனர்.",
  teams_new_chat_account: "கணக்கு",
};
